/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AITestResponseTypeEnum {
  TextResponse = "TextResponse",
  VideoResponse = "VideoResponse",
}

export enum AITestTypeEnum {
  TextTest = "TextTest",
  VideoTest = "VideoTest",
}

export enum AchievementTypeEnum {
  DailyGoal = "DailyGoal",
  DailyWarmup = "DailyWarmup",
  HoursUsed = "HoursUsed",
  LevelUpInEveryGame = "LevelUpInEveryGame",
  LevelUpInReaderGame = "LevelUpInReaderGame",
  PracticeTest = "PracticeTest",
  TestCompeted = "TestCompeted",
}

export enum AdditionalTestTypeEnum {
  AdditionalBiologyTests = "AdditionalBiologyTests",
  AdditionalFLTests = "AdditionalFLTests",
  AdditionalGeneralChemistryTests = "AdditionalGeneralChemistryTests",
  AdditionalOrganicChemistryTests = "AdditionalOrganicChemistryTests",
  AdditionalPATTests = "AdditionalPATTests",
  AdditionalQRTests = "AdditionalQRTests",
  AdditionalRCTests = "AdditionalRCTests",
}

export enum AwardTypeEnum {
  MembershipExtension = "MembershipExtension",
  MysteryBox = "MysteryBox",
}

export enum CMSBoosterPages {
  CrashCourses = "CrashCourses",
  Dentistry = "Dentistry",
  HomePage = "HomePage",
  Optometry = "Optometry",
  Product = "Product",
  Review = "Review",
  SuccessStory = "SuccessStory",
  UpgradePage = "UpgradePage",
}

export enum CMSScreenshotPages {
  CrashCourses = "CrashCourses",
  Review = "Review",
  SuccessStory = "SuccessStory",
  UpgradePage = "UpgradePage",
}

export enum CanadianDatTipsTypeEnum {
  OnDayOfDAT = "OnDayOfDAT",
  PreparingForDAT = "PreparingForDAT",
  SoapCarvingTips = "SoapCarvingTips",
  TakingNotes = "TakingNotes",
}

export enum CancellationReasonEnum {
  AlreadyTakenClasses = "AlreadyTakenClasses",
  FoundBetterAlternative = "FoundBetterAlternative",
  NotHelpingImprove = "NotHelpingImprove",
  NotUsingEnough = "NotUsingEnough",
  Other = "Other",
  TooExpensive = "TooExpensive",
}

export enum ClassroomTabEnum {
  Analyzers = "Analyzers",
  CheatSheets = "CheatSheets",
  CommunityTestlets = "CommunityTestlets",
  DLOSCEQuestionBanks = "DLOSCEQuestionBanks",
  FlashCards = "FlashCards",
  GeneratorAndAnalyzer = "GeneratorAndAnalyzer",
  Generators = "Generators",
  MultiselectOSCEQBanks = "MultiselectOSCEQBanks",
  PATStrategies = "PATStrategies",
  PracticeTests = "PracticeTests",
  QuestionBanks = "QuestionBanks",
  ReactionQbank = "ReactionQbank",
  ReadingPracticeTests = "ReadingPracticeTests",
  ReadingQuestionBanks = "ReadingQuestionBanks",
  ReadingStrategies = "ReadingStrategies",
  RecommendedArticles = "RecommendedArticles",
  Reporting = "Reporting",
  RxWritingDLOSCEQBanks = "RxWritingDLOSCEQBanks",
  RxWritingOSCEQBanks = "RxWritingOSCEQBanks",
  StandaloneOSCEQBanks = "StandaloneOSCEQBanks",
  StudyNotes = "StudyNotes",
  VideoContent = "VideoContent",
  VocabularyEnhancer = "VocabularyEnhancer",
}

export enum DentalSchoolsEnum {
  ATSUArizona = "ATSUArizona",
  ATSUMissouri = "ATSUMissouri",
  Alabama = "Alabama",
  ArizonaCollege = "ArizonaCollege",
  Augusta = "Augusta",
  Booster = "Booster",
  Boston = "Boston",
  Buffalo = "Buffalo",
  CaliforniaNorthstate = "CaliforniaNorthstate",
  CaseWestern = "CaseWestern",
  ChicagoCollege = "ChicagoCollege",
  ClaytonStateUniversity = "ClaytonStateUniversity",
  CollegeOfSouthernNevada = "CollegeOfSouthernNevada",
  Colorado = "Colorado",
  Columbia = "Columbia",
  CommunityCollegeOfDenver = "CommunityCollegeOfDenver",
  Connecticut = "Connecticut",
  Creighton = "Creighton",
  Dentactics = "Dentactics",
  DentalCollegeOfGeorgiaAtAugustaUniversity = "DentalCollegeOfGeorgiaAtAugustaUniversity",
  DixieStateUniversity = "DixieStateUniversity",
  EastCarolina = "EastCarolina",
  EastTennesseeStateUniversity = "EastTennesseeStateUniversity",
  EasternWashingtonUAtPierceCollege = "EasternWashingtonUAtPierceCollege",
  FarmingdaleStateCollegeOfNewYork = "FarmingdaleStateCollegeOfNewYork",
  FerrisStateUniversity = "FerrisStateUniversity",
  Florida = "Florida",
  FoothillCollege = "FoothillCollege",
  GeorgiaHighlandsCollege = "GeorgiaHighlandsCollege",
  Harvard = "Harvard",
  HighPoint = "HighPoint",
  Howard = "Howard",
  IllinoisChicago = "IllinoisChicago",
  IllinoisCollege = "IllinoisCollege",
  Indiana = "Indiana",
  IndianaUniversity = "IndianaUniversity",
  IndianaUniversitySchoolOfDentistry = "IndianaUniversitySchoolOfDentistry",
  IndianaUniversitySouthBend = "IndianaUniversitySouthBend",
  InterAmericanUniversity = "InterAmericanUniversity",
  KansasCity = "KansasCity",
  Kentucky = "Kentucky",
  KentuckyCollege = "KentuckyCollege",
  LECOM = "LECOM",
  LincolnMemorial = "LincolnMemorial",
  LomaLindaUniversity = "LomaLindaUniversity",
  LouisianaState = "LouisianaState",
  Louisville = "Louisville",
  MarianUniversity = "MarianUniversity",
  Marquette = "Marquette",
  Maryland = "Maryland",
  MassachusettsCollege = "MassachusettsCollege",
  MedicalUSC = "MedicalUSC",
  Meharry = "Meharry",
  MetropolitanStateUniversity = "MetropolitanStateUniversity",
  MichiganCollege = "MichiganCollege",
  MidwesternAZ = "MidwesternAZ",
  MidwesternIL = "MidwesternIL",
  Minnesota = "Minnesota",
  MinnesotaStateUniversityMankato = "MinnesotaStateUniversityMankato",
  Mississippi = "Mississippi",
  MissouriKansasCity = "MissouriKansasCity",
  MountIdaCollege = "MountIdaCollege",
  Nebraska = "Nebraska",
  NevadaLasVegas = "NevadaLasVegas",
  NewEnglandCollege = "NewEnglandCollege",
  NewYorkUniversity = "NewYorkUniversity",
  NorthCarolina = "NorthCarolina",
  NortheasternStateUniversity = "NortheasternStateUniversity",
  NorthernArizonaUniversity = "NorthernArizonaUniversity",
  NovaSoutheastern = "NovaSoutheastern",
  NovaSoutheasternUniversity = "NovaSoutheasternUniversity",
  OhioStateUniversity = "OhioStateUniversity",
  Oklahoma = "Oklahoma",
  OldDominionUniversity = "OldDominionUniversity",
  OregonHealth = "OregonHealth",
  OregonInstituteOfTechnology = "OregonInstituteOfTechnology",
  Pacific = "Pacific",
  PacificUniversity = "PacificUniversity",
  Pennsylvania = "Pennsylvania",
  PennsylvaniaCollege = "PennsylvaniaCollege",
  PennsylvaniaCollegeOfTechnology = "PennsylvaniaCollegeOfTechnology",
  PuebloCommunityCollege = "PuebloCommunityCollege",
  PuertoRico = "PuertoRico",
  RockyMountainUniversityOfHealthProfessions = "RockyMountainUniversityOfHealthProfessions",
  Roseman = "Roseman",
  RosenbergSchool = "RosenbergSchool",
  Rutgers = "Rutgers",
  SouthernCalifornia = "SouthernCalifornia",
  SouthernCaliforniaCollege = "SouthernCaliforniaCollege",
  SouthernCollege = "SouthernCollege",
  SouthernIllinoisUniversity = "SouthernIllinoisUniversity",
  StPetersburgCollege = "StPetersburgCollege",
  StateUniversityOfNewYork = "StateUniversityOfNewYork",
  StonyBrook = "StonyBrook",
  SunyAtCanton = "SunyAtCanton",
  Temple = "Temple",
  Tennessee = "Tennessee",
  TennesseeStateUniversity = "TennesseeStateUniversity",
  TexasAM = "TexasAM",
  TexasHouston = "TexasHouston",
  TexasSanAntonio = "TexasSanAntonio",
  TexasTech = "TexasTech",
  TexasWomansUniversity = "TexasWomansUniversity",
  TheIowa = "TheIowa",
  Touro = "Touro",
  Tufts = "Tufts",
  TylerJuniorCollege = "TylerJuniorCollege",
  UCBerkeleySchool = "UCBerkeleySchool",
  UCLA = "UCLA",
  UCSF = "UCSF",
  UOfTexasHealthScienceCenterAtSanAntonio = "UOfTexasHealthScienceCenterAtSanAntonio",
  UnivOfTexasHealthScienceCenterAtHouston = "UnivOfTexasHealthScienceCenterAtHouston",
  UniversityOfAlabama = "UniversityOfAlabama",
  UniversityOfAlaska = "UniversityOfAlaska",
  UniversityOfBridgeport = "UniversityOfBridgeport",
  UniversityOfDetroitMercy = "UniversityOfDetroitMercy",
  UniversityOfHouston = "UniversityOfHouston",
  UniversityOfLouisianaAtMonroe = "UniversityOfLouisianaAtMonroe",
  UniversityOfMaineAtAugustaBangorCampus = "UniversityOfMaineAtAugustaBangorCampus",
  UniversityOfMarylandBaltimore = "UniversityOfMarylandBaltimore",
  UniversityOfMichigan = "UniversityOfMichigan",
  UniversityOfMississippiMedicalCenter = "UniversityOfMississippiMedicalCenter",
  UniversityOfMissouri = "UniversityOfMissouri",
  UniversityOfMissouriKansasCity = "UniversityOfMissouriKansasCity",
  UniversityOfMontreal = "UniversityOfMontreal",
  UniversityOfNewEngland = "UniversityOfNewEngland",
  UniversityOfNewHaven = "UniversityOfNewHaven",
  UniversityOfNewMexico = "UniversityOfNewMexico",
  UniversityOfPittsburgh = "UniversityOfPittsburgh",
  UniversityOfSouthernIndiana = "UniversityOfSouthernIndiana",
  UniversityOfWaterloo = "UniversityOfWaterloo",
  Utah = "Utah",
  VermontTechnicalCollege = "VermontTechnicalCollege",
  Virginia = "Virginia",
  Washington = "Washington",
  WePrep = "WePrep",
  WeberStateUniversity = "WeberStateUniversity",
  WestLibertyUniversity = "WestLibertyUniversity",
  WestLosAngelesCollege = "WestLosAngelesCollege",
  WestVirginiaUniversity = "WestVirginiaUniversity",
  Western = "Western",
  WesternKentuckyUniversity = "WesternKentuckyUniversity",
  WesternUniversityOfHealthSciences = "WesternUniversityOfHealthSciences",
  WichitaStateUniversity = "WichitaStateUniversity",
}

export enum DeviceTypeEnum {
  Desktop = "Desktop",
  Mobile = "Mobile",
  MobileBrowser = "MobileBrowser",
}

export enum EmailTemplateTypeEnum {
  CrashCoursePurchased = "CrashCoursePurchased",
  FreeActivation = "FreeActivation",
  MembershipCanceled = "MembershipCanceled",
  MembershipCanceledAdmin = "MembershipCanceledAdmin",
  MembershipExpiration = "MembershipExpiration",
  PaidActivation = "PaidActivation",
  PasswordReset = "PasswordReset",
  PauseUnpauseMembership = "PauseUnpauseMembership",
  PaymentFailed = "PaymentFailed",
  PaymentFailedAdmin = "PaymentFailedAdmin",
  PurchaseComplete = "PurchaseComplete",
}

export enum ExtensionQuestionDifficultyEnum {
  Difficult = "Difficult",
  Easy = "Easy",
  Expert = "Expert",
  Moderate = "Moderate",
}

export enum ExtensionStatusEnum {
  Error = "Error",
  Info = "Info",
  Okay = "Okay",
  Warning = "Warning",
}

export enum ExtensionType {
  Extension = "Extension",
}

export enum FacultyModeCohortYearEnum {
  ClassOf2024 = "ClassOf2024",
  ClassOf2025 = "ClassOf2025",
  ClassOf2026 = "ClassOf2026",
  ClassOf2027 = "ClassOf2027",
  ClassOf2028 = "ClassOf2028",
  ClassOf2029 = "ClassOf2029",
  ClassOf2030 = "ClassOf2030",
  ClassOf2031 = "ClassOf2031",
  ClassOf2032 = "ClassOf2032",
  ClassOf2033 = "ClassOf2033",
  ClassOf2034 = "ClassOf2034",
  ClassOf2035 = "ClassOf2035",
  ClassOf2037 = "ClassOf2037",
  ClassOf2038 = "ClassOf2038",
  ClassOf2039 = "ClassOf2039",
  ClassOf2040 = "ClassOf2040",
  ClassOf2041 = "ClassOf2041",
  ClassOf2042 = "ClassOf2042",
  ClassOf2043 = "ClassOf2043",
  ClassOf2044 = "ClassOf2044",
}

export enum FaqPages {
  AAMCPlugin = "AAMCPlugin",
  AAMCPluginHowToUse = "AAMCPluginHowToUse",
  AccountSettings = "AccountSettings",
  AchievementsAndRewards = "AchievementsAndRewards",
  CaseBasedScenario = "CaseBasedScenario",
  CheatSheetPreLaunch = "CheatSheetPreLaunch",
  Classroom = "Classroom",
  ContentCompletion = "ContentCompletion",
  CrashCourses = "CrashCourses",
  CustomScheduler = "CustomScheduler",
  DailyCarsPractice = "DailyCarsPractice",
  DailyGoalCalendar = "DailyGoalCalendar",
  DailyWarmupCalendar = "DailyWarmupCalendar",
  DentalSchool = "DentalSchool",
  Dentistry = "Dentistry",
  FullTests = "FullTests",
  Game = "Game",
  HomePage = "HomePage",
  InfluencerHub = "InfluencerHub",
  MCATScoreCalculation = "MCATScoreCalculation",
  MockExam = "MockExam",
  Optometry = "Optometry",
  OptometrySchool = "OptometrySchool",
  PATGenerators = "PATGenerators",
  Performance = "Performance",
  PracticeTestAnalytics = "PracticeTestAnalytics",
  StudyGuide = "StudyGuide",
  UpgradePage = "UpgradePage",
}

export enum FaqTypeEnum {
  HigherScore = "HigherScore",
  Standard = "Standard",
}

export enum FileProcessingStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
}

export enum GameChallengeTypeEnum {
  AngleRankingChallenge = "AngleRankingChallenge",
  BiologyChallenge = "BiologyChallenge",
  CubeCountingChallenge = "CubeCountingChallenge",
  DiagnosisDisordersChallenge = "DiagnosisDisordersChallenge",
  FieldsOfDentistryChallenge = "FieldsOfDentistryChallenge",
  GeneralChemistryChallenge = "GeneralChemistryChallenge",
  HolePunchingChallenge = "HolePunchingChallenge",
  OralMedicinePathologyChallenge = "OralMedicinePathologyChallenge",
  OrganicChemistryChallenge = "OrganicChemistryChallenge",
  PathologyRadiologyChallenge = "PathologyRadiologyChallenge",
  PharmacologyChallenge = "PharmacologyChallenge",
  QuantitativeReasoningChallenge = "QuantitativeReasoningChallenge",
  ReactionQBankChallenge = "ReactionQBankChallenge",
  TypingTestChallenge = "TypingTestChallenge",
}

export enum GroupIcon {
  Download = "Download",
  Flash = "Flash",
  Star = "Star",
}

export enum InfluencerPlatformEnum {
  Instagram = "Instagram",
  TikTok = "TikTok",
  Youtube = "Youtube",
}

export enum InfluencerTypeEnum {
  DoctorInfluencer = "DoctorInfluencer",
  FeaturedInfluencer = "FeaturedInfluencer",
  MedicalStudentInfluencer = "MedicalStudentInfluencer",
  PreMedicalStudentInfluencer = "PreMedicalStudentInfluencer",
}

export enum LevelEnum {
  Level1 = "Level1",
  Level10 = "Level10",
  Level2 = "Level2",
  Level3 = "Level3",
  Level4 = "Level4",
  Level5 = "Level5",
  Level6 = "Level6",
  Level7 = "Level7",
  Level8 = "Level8",
  Level9 = "Level9",
}

export enum MainBadgeEnum {
  BestValue = "BestValue",
  MostFlexible = "MostFlexible",
  MostPopular = "MostPopular",
  None = "None",
}

export enum MembershipStatus {
  Active = "Active",
  Expired = "Expired",
  Paused = "Paused",
}

export enum MembershipType {
  Free = "Free",
  Premium = "Premium",
  PremiumMax = "PremiumMax",
}

/**
 * Type of MFA used by the user
 */
export enum MfaTypeEnum {
  APP = "APP",
  SMS = "SMS",
}

export enum OrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum PassageSubCategoryEnum {
  Anthropology = "Anthropology",
  Archaeology = "Archaeology",
  Architecture = "Architecture",
  Art = "Art",
  Dance = "Dance",
  Economics = "Economics",
  Education = "Education",
  Ethics = "Ethics",
  Geography = "Geography",
  History = "History",
  Linguistics = "Linguistics",
  Literature = "Literature",
  Music = "Music",
  Philosophy = "Philosophy",
  PoliticalScience = "PoliticalScience",
  PopularCulture = "PopularCulture",
  PopulationHealth = "PopulationHealth",
  Psychology = "Psychology",
  Religion = "Religion",
  Sociology = "Sociology",
  StudiesOfDiverseCultures = "StudiesOfDiverseCultures",
  Theater = "Theater",
}

export enum PassageTypeEnum {
  Humanities = "Humanities",
  SocialSciences = "SocialSciences",
}

export enum PlatformCategory {
  ApplyingThisCycle = "ApplyingThisCycle",
  Casper = "Casper",
  DentalHygiene = "DentalHygiene",
  Dentistry = "Dentistry",
  GraduateExams = "GraduateExams",
  Medicine = "Medicine",
  Optometry = "Optometry",
}

export enum PlatformName {
  Admissions = "Admissions",
  CARSBooster = "CARSBooster",
  CasperBooster = "CasperBooster",
  DATBooster = "DATBooster",
  DATCrusher = "DATCrusher",
  DLOSCE = "DLOSCE",
  GREBooster = "GREBooster",
  INBDEBooster = "INBDEBooster",
  MCATBooster = "MCATBooster",
  NBDHEBooster = "NBDHEBooster",
  NBEOPartOne = "NBEOPartOne",
  NDEBCrusher = "NDEBCrusher",
  OATBooster = "OATBooster",
  PATBooster = "PATBooster",
}

export enum PracticeTestTypeEnum {
  CarsPracticePassage = "CarsPracticePassage",
  CarsPracticeTest = "CarsPracticeTest",
  CreatedTest = "CreatedTest",
  DailyCarsPractice = "DailyCarsPractice",
  InPersonMockTest = "InPersonMockTest",
  MiniTest = "MiniTest",
  MockTest = "MockTest",
  MockTestLegacy = "MockTestLegacy",
  MultiSectionGREPracticeTest = "MultiSectionGREPracticeTest",
  PracticeTest = "PracticeTest",
  ReadingMiniTest = "ReadingMiniTest",
  ReadingPracticeTest = "ReadingPracticeTest",
  ReadingQuestionBank = "ReadingQuestionBank",
}

export enum ProductStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export enum ProductTypeEnum {
  AdditionalBiologyTests = "AdditionalBiologyTests",
  AdditionalFLTests = "AdditionalFLTests",
  AdditionalGeneralChemistryTests = "AdditionalGeneralChemistryTests",
  AdditionalOrganicChemistryTests = "AdditionalOrganicChemistryTests",
  AdditionalPATTests = "AdditionalPATTests",
  AdditionalRCTests = "AdditionalRCTests",
  Extension = "Extension",
  Free = "Free",
  Premium = "Premium",
  PremiumMax = "PremiumMax",
}

export enum PromocodeHistoryDisplayByTypeEnum {
  DAYS = "DAYS",
  MONTHS = "MONTHS",
}

export enum PromocodeStatusEnum {
  Active = "Active",
  Expired = "Expired",
}

export enum PromocodeTypeEnum {
  Fixed = "Fixed",
  Percentage = "Percentage",
}

export enum QuestionInvertTypeEnum {
  AUTO = "AUTO",
  NO = "NO",
  YES = "YES",
}

export enum QuestionLocationTypeEnum {
  MiniTest = "MiniTest",
  PT = "PT",
  QB = "QB",
  Video = "Video",
}

export enum QuestionTypeEnum {
  CaseNBDHE = "CaseNBDHE",
  MultiChoiceDLOSCE = "MultiChoiceDLOSCE",
  MultiChoiceGre = "MultiChoiceGre",
  MultiChoiceNBEO = "MultiChoiceNBEO",
  MultiChoiceNDEB = "MultiChoiceNDEB",
  NumericResponse = "NumericResponse",
  PassageMultiChoiceGRE = "PassageMultiChoiceGRE",
  PassageSingleChoiceGRE = "PassageSingleChoiceGRE",
  RxWritingNDEB = "RxWritingNDEB",
  SentenceEquivalence = "SentenceEquivalence",
  SingleChoice = "SingleChoice",
  SingleChoiceCARS = "SingleChoiceCARS",
  SingleChoiceDLOSCE = "SingleChoiceDLOSCE",
  SingleChoiceGRE = "SingleChoiceGRE",
  SingleChoiceInbde = "SingleChoiceInbde",
  SingleChoiceNBEO = "SingleChoiceNBEO",
  SingleChoiceNDEB = "SingleChoiceNDEB",
  TestletNBDHE = "TestletNBDHE",
  TextCompletion = "TextCompletion",
}

export enum ReTrainingStatus {
  Cancelled = "Cancelled",
  Failed = "Failed",
  Queued = "Queued",
  Running = "Running",
  Succeeded = "Succeeded",
  ValidatingFiles = "ValidatingFiles",
}

export enum RewardTypeEnum {
  Extension = "Extension",
  FreeMissedStreak = "FreeMissedStreak",
  MysteryBox = "MysteryBox",
  PauseToken = "PauseToken",
  PrizeSelector = "PrizeSelector",
}

export enum RolesEnum {
  AITrainer = "AITrainer",
  Admin = "Admin",
  Marketing = "Marketing",
  SuperAdmin = "SuperAdmin",
  Teacher = "Teacher",
  UGCCreator = "UGCCreator",
  User = "User",
}

export enum SchoolLocationTypeEnum {
  American = "American",
  Canadian = "Canadian",
  Optometry = "Optometry",
}

/**
 * Search type: ful text or regex
 */
export enum SearchTypeEnum {
  FullText = "FullText",
  ILike = "ILike",
}

export enum SecondaryBadgeEnum {
  HigherScoreGuarantee = "HigherScoreGuarantee",
  None = "None",
  UpdatedForYear = "UpdatedForYear",
}

export enum ServiceCategoryTypeEnum {
  CompleteApplication = "CompleteApplication",
  InterviewPrep = "InterviewPrep",
  SecondaryApplication = "SecondaryApplication",
}

export enum ServicePageTypeEnum {
  Dentistry = "Dentistry",
  Optometry = "Optometry",
}

export enum StudyGuideIconEnum {
  Anki = "Anki",
  Book = "Book",
  Checkmark = "Checkmark",
  Light = "Light",
  Person = "Person",
  Stats = "Stats",
  Target = "Target",
  Text = "Text",
}

export enum StudyScheduleTaskViewEnum {
  Clean = "Clean",
  Compact = "Compact",
  Detailed = "Detailed",
}

export enum StudyScheduleViewEnum {
  DailyView = "DailyView",
  FullScheduleView = "FullScheduleView",
  WeeklyView = "WeeklyView",
}

export enum SubjectEnumType {
  CmsOnly = "CmsOnly",
  Common = "Common",
  Game = "Game",
  Regular = "Regular",
  VideosOnly = "VideosOnly",
}

export enum SubscriptionStatus {
  Active = "Active",
  Canceled = "Canceled",
  CardDeclined = "CardDeclined",
  ExpiredCard = "ExpiredCard",
  InsufficientFunds = "InsufficientFunds",
  InvalidCard = "InvalidCard",
}

export enum TaskTypeEnum {
  Custom = "Custom",
  PracticeTest = "PracticeTest",
  QBank = "QBank",
  Resource = "Resource",
  Video = "Video",
}

export enum TimeRecordEnum {
  NonTimed = "NonTimed",
  Timed = "Timed",
}

export enum UGCCreationDataStatusEnum {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
}

export enum UserBlockHistoryStatusEnum {
  AccountBlocked = "AccountBlocked",
  AccountUnblocked = "AccountUnblocked",
  CreationWarning = "CreationWarning",
  ScreenshotWarning = "ScreenshotWarning",
  TestWarning = "TestWarning",
}

export enum UserStudyScheduleStudySpeedEnum {
  Faster = "Faster",
  Ludicrous = "Ludicrous",
  NoRush = "NoRush",
  Normal = "Normal",
  Relaxed = "Relaxed",
}

export interface AccommodationInput {
  platform: PlatformName;
  value: number;
}

export interface AchievementOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
}

export interface AchievementQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  where?: AchievementWhere | null;
  order?: AchievementOrder | null;
}

export interface AchievementWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  isLive?: boolean | null;
  type?: AchievementTypeEnum | null;
  amountRequired?: number | null;
  order?: number | null;
  awardType?: AwardTypeEnum | null;
  awardTypeValue?: number | null;
  description?: string | null;
  level?: number | null;
  platform?: FindByPlatformInput | null;
}

export interface AdditionalTestOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface AdditionalTestQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: AdditionalTestWhere | null;
  order?: AdditionalTestOrder | null;
}

export interface AdditionalTestWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  name?: string | null;
  type?: AdditionalTestTypeEnum | null;
  description?: string | null;
  practiceTests?: LinkPracticeTestInput[] | null;
  price?: number | null;
  status?: ProductStatus | null;
  order?: number | null;
  isMostPopular?: boolean | null;
  ligthModeImageUrl?: string | null;
  darkModeImageUrl?: string | null;
  promocode?: LinkPromocodeInput[] | null;
  subject?: SubjectAddTestsFilter | null;
}

export interface AdmissionExpertOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface AdmissionExpertQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: AdmissionExpertWhere | null;
  order?: AdmissionExpertOrder | null;
}

export interface AdmissionExpertWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  page?: ServicePageTypeEnum | null;
  avatar?: string | null;
  name?: string | null;
  degree?: string | null;
  description?: string | null;
  email?: string | null;
  platform?: LinkPlatformInput | null;
}

export interface AdmissionServiceOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface AdmissionServiceQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: AdmissionServiceWhere | null;
  order?: AdmissionServiceOrder | null;
}

export interface AdmissionServiceWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  page?: ServicePageTypeEnum | null;
  category?: ServiceCategoryTypeEnum | null;
  title?: string | null;
  isPopular?: boolean | null;
  price?: number | null;
  originalPrice?: number | null;
  feature?: string[] | null;
  paymentLink?: string | null;
  description?: string | null;
  platform?: LinkPlatformInput | null;
}

export interface AiTestOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
  isLive?: OrderDirection | null;
}

export interface AiTestQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: AiTestWhere | null;
  order?: AiTestOrder | null;
}

export interface AiTestQuestionInput {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title: string;
  questionText: string;
  order: number;
  bestResponseVideoUrl?: string | null;
  bestResponseText?: string | null;
  isLive: boolean;
}

export interface AiTestTrainingDataHistoryOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface AiTestTrainingDataHistoryQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: AiTestTrainingDataHistoryWhere | null;
  order?: AiTestTrainingDataHistoryOrder | null;
}

export interface AiTestTrainingDataHistoryWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  jobId?: string | null;
  status?: ReTrainingStatus | null;
  errorMessage?: string | null;
  user?: LinkUserInput | null;
}

export interface AiTestTrainingDataOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface AiTestTrainingDataQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: AiTestTrainingDataWhere | null;
  order?: AiTestTrainingDataOrder | null;
}

export interface AiTestTrainingDataWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  answerText?: string | null;
  quartile?: number | null;
  quartileExplanation?: string | null;
  responseFeedback?: string | null;
  isFromAI?: boolean | null;
  userEmail?: string | null;
  testType?: AITestTypeEnum | null;
  question?: LinkAiTestQuestionInput | null;
}

export interface AiTestWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  type?: AITestTypeEnum | null;
  responseType?: AITestResponseTypeEnum | null;
  description?: string | null;
  contextVideoUrl?: string | null;
  contextText?: string | null;
  videoText?: string | null;
  order?: number | null;
  isLive?: boolean | null;
  membershipLevel?: MembershipType | null;
  questions?: AiTestQuestionInput[] | null;
  casperFullLengthTest?: LinkCasperFullLengthTestInput | null;
}

export interface AnswerInput {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  textAsHtml: string;
  point: number;
  order?: number | null;
  isCorrect: boolean;
}

export interface BaseDateRangeFilter {
  createdAt?: EntityDateRangeFilterInput | null;
  updatedAt?: EntityDateRangeFilterInput | null;
}

export interface BreakSectionsInput {
  id: string;
  questionIndex: number;
  duration: number;
}

export interface BulkCreateUpdateFaqInput {
  question?: string | null;
  answerAsHtml?: string | null;
  page?: FaqPages | null;
  order?: number | null;
  type?: FaqTypeEnum | null;
  platform?: LinkPlatformInput | null;
  id?: string | null;
}

export interface BulkUpdateAchievementsInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateAiTestInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateChapterNotesInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateCheatSheetGroupInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateCheatSheetInput {
  id?: string | null;
  order?: number | null;
}

export interface BulkUpdateFlashCardGroupInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateFlashCardInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateInfluencerHubInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdatePracticeTestCategoryInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdatePracticeTestInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdatePracticeTestResultInput {
  practiceTestResult: PTResultWithoutHistory[];
  history?: HistoryInput[] | null;
}

export interface BulkUpdatePromocodeInput {
  id?: string | null;
  expirationDate?: any | null;
  status: PromocodeStatusEnum;
  platform: LinkPlatformInput;
}

export interface BulkUpdateQuestionBankCategoryInput {
  id?: string | null;
  order?: number | null;
}

export interface BulkUpdateQuestionBankInput {
  id?: string | null;
  order?: number | null;
}

export interface BulkUpdateRecommendedArticleGroupInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateRecommendedArticleInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateRewardInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateStrategyGroupInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateStrategyInput {
  id?: string | null;
  order?: number | null;
}

export interface BulkUpdateStudyNoteGroupInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateStudyNoteInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateTextFeedbackInput {
  id?: string | null;
  order?: number | null;
}

export interface BulkUpdateTmLinkInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateVideoCategoryInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateVideoInput {
  id?: string | null;
  order: number;
}

export interface BulkUpdateVideoReviewInput {
  id?: string | null;
  order: number;
}

export interface CMSStudentInput {
  fullName: string;
  avatar: string;
  score: string;
}

export interface CanadianDatTipOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface CanadianDatTipQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: CanadianDatTipWhere | null;
  order?: CanadianDatTipOrder | null;
}

export interface CanadianDatTipWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: CanadianDatTipsTypeEnum | null;
  description?: string | null;
}

export interface CancellationUsersInput {
  platformId: string;
  startDate?: any | null;
  endDate?: any | null;
  search?: SearchInput | null;
  cancellationReason?: CancellationReasonEnum | null;
  hasCancellationComment?: boolean | null;
  skip?: number | null;
  take?: number | null;
}

export interface ChapterNotesOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
}

export interface ChapterNotesQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: ChapterNotesWhere | null;
  order?: ChapterNotesOrder | null;
}

export interface ChapterNotesWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  link?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
}

export interface CheatSheetGroupOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
  cheatSheetsOrder?: OrderDirection | null;
}

export interface CheatSheetGroupQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: CheatSheetGroupWhere | null;
  order?: CheatSheetGroupOrder | null;
}

export interface CheatSheetGroupWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: GroupIcon | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  cheatSheet?: LinkCheatSheetInput[] | null;
}

export interface CheatSheetOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
}

export interface CheatSheetQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: CheatSheetWhere | null;
  order?: CheatSheetOrder | null;
}

export interface CheatSheetWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  cheatSheetGroup?: LinkCheatSheetGroupInput | null;
  isBoosterEnvironment?: boolean | null;
  title?: string | null;
  description?: string | null;
  link?: string | null;
  landingPageDescription?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
  isDocumentUpdated?: boolean | null;
  subject?: LinkSubjectInput | null;
}

export interface CodesOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  activationDate?: OrderDirection | null;
  code?: OrderDirection | null;
  duration?: OrderDirection | null;
  email?: OrderDirection | null;
  name?: OrderDirection | null;
}

export interface CodesQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: CodesWhere | null;
  order?: CodesOrder | null;
}

export interface CodesWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  email?: string | null;
  membershipType?: MembershipType | null;
  duration?: string | null;
  userRole?: RolesEnum | null;
  institutionalCodes?: LinkInstitutionalCodesInput | null;
}

export interface CrashCourseOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface CrashCourseQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: CrashCourseWhere | null;
  order?: CrashCourseOrder | null;
}

export interface CrashCourseWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  courseName?: string | null;
  order?: number | null;
  author?: LinkTeamMemberInput[] | null;
  price?: string | null;
  startDate?: any | null;
  topics?: string[] | null;
  link?: string | null;
  additionalInfo?: string | null;
  subject?: LinkSubjectInput | null;
}

export interface CreateAchievementInput {
  isLive: boolean;
  type: AchievementTypeEnum;
  amountRequired: number;
  order: number;
  awardType?: AwardTypeEnum | null;
  awardTypeValue: number;
  description: string;
  level: number;
  platform: LinkPlatformInput;
}

export interface CreateAdmissionExpertInput {
  page?: ServicePageTypeEnum | null;
  avatar?: string | null;
  name?: string | null;
  degree?: string | null;
  description?: string | null;
  email?: string | null;
  platform?: LinkPlatformInput | null;
}

export interface CreateAiTestInput {
  title?: string | null;
  type?: AITestTypeEnum | null;
  responseType?: AITestResponseTypeEnum | null;
  description?: string | null;
  contextVideoUrl?: string | null;
  contextText?: string | null;
  videoText?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
  casperFullLengthTest?: LinkCasperFullLengthTestInput | null;
  questions: AiTestQuestionInput[];
}

export interface CreateAiTestTrainingDataInput {
  answerText?: string | null;
  quartile?: number | null;
  quartileExplanation?: string | null;
  responseFeedback?: string | null;
  isFromAI?: boolean | null;
  userEmail?: string | null;
  testType?: AITestTypeEnum | null;
  question?: LinkAiTestQuestionInput | null;
}

export interface CreateChapterNotesInput {
  title?: string | null;
  link?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
}

export interface CreateCheatSheetGroupInput {
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: GroupIcon | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  cheatSheet?: LinkCheatSheetInput[] | null;
}

export interface CreateCheatSheetInput {
  cheatSheetGroup?: LinkCheatSheetGroupInput | null;
  isBoosterEnvironment?: boolean | null;
  title?: string | null;
  description?: string | null;
  link?: string | null;
  landingPageDescription?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
  isDocumentUpdated?: boolean | null;
}

export interface CreateCodesInput {
  email?: string | null;
  membershipType?: MembershipType | null;
  duration?: string | null;
  userRole: RolesEnum;
  institutionalCodes?: LinkInstitutionalCodesInput | null;
}

export interface CreateCrashCourseInput {
  courseName?: string | null;
  order?: number | null;
  author?: LinkTeamMemberInput[] | null;
  price?: string | null;
  startDate?: any | null;
  topics?: string[] | null;
  link?: string | null;
  additionalInfo?: string | null;
  subject?: LinkSubjectInput | null;
}

export interface CreateDentalSchoolInput {
  title?: string | null;
  image?: string | null;
  description?: string | null;
  isFeaturedExperts?: boolean | null;
  slug?: string | null;
  infoFirstColumn?: string[] | null;
  infoSecondColumn?: string[] | null;
  isOptometry?: boolean | null;
  details?: DentalSchoolDetailsInput[] | null;
  location?: LinkDentalSchoolLocationInput[] | null;
  platform?: LinkPlatformInput | null;
}

export interface CreateDentalSchoolLocationInput {
  title?: string | null;
  description?: string | null;
  schoolLocationType?: SchoolLocationTypeEnum | null;
  platform?: LinkPlatformInput | null;
  dentalSchoolIds?: string[] | null;
  isOptometry?: boolean | null;
  dentalSchool?: LinkDentalSchoolInput[] | null;
}

export interface CreateFlashCardGroupInput {
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: GroupIcon | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  flashCard?: LinkFlashCardInput[] | null;
}

export interface CreateFlashCardInput {
  name?: string | null;
  link?: string | null;
  flashCardGroup?: LinkFlashCardGroupInput | null;
  description?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
}

export interface CreateInfluencerHubInput {
  name?: string | null;
  coverImage?: string | null;
  description?: string | null;
  influencerPlatform?: InfluencerPlatformEnum | null;
  socialLink?: string | null;
  influencerType?: InfluencerTypeEnum | null;
  order?: number | null;
}

export interface CreateInstitutionalCodesInput {
  university?: DentalSchoolsEnum | null;
  cohort?: FacultyModeCohortYearEnum | null;
  platform?: LinkPlatformInput | null;
}

export interface CreatePracticeTestCategoryInput {
  title?: string | null;
  isLive?: boolean | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  membershipLevel?: MembershipType | null;
}

export interface CreatePracticeTestInput {
  title?: string | null;
  isLive?: boolean | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  duration?: number | null;
  questions?: LinkQuestionInput[] | null;
  questionIds?: string[] | null;
  timeRecord?: TimeRecordEnum | null;
  membershipLevel?: MembershipType | null;
  pageDescriptionAsHtml?: string | null;
  introAsHtml?: string | null;
  type?: PracticeTestTypeEnum | null;
  practiceTestCategory?: LinkPracticeTestCategoryInput | null;
  history?: HistoryInput[] | null;
  breaksSections?: BreakSectionsInput[] | null;
  slug?: string | null;
  university?: DentalSchoolsEnum | null;
  testResult: PracticeTestResultInput[];
  passage: PassageInput[];
}

export interface CreateProductInput {
  stripeProductId?: string | null;
  name: string;
  status?: ProductStatus | null;
  duration: string;
  price: number;
  type?: ProductTypeEnum | null;
  isExtension?: boolean | null;
  isSubscription?: boolean | null;
  order?: number | null;
  platform: LinkPlatformInput;
  promocode?: LinkPromocodeInput[] | null;
  description: string;
  originalPrice: number;
  imageKey: string;
}

export interface CreatePromocodeInput {
  name?: string | null;
  description?: string | null;
  code?: string | null;
  type?: PromocodeTypeEnum | null;
  amount?: number | null;
  expirationDate?: any | null;
  status?: PromocodeStatusEnum | null;
  maxUses?: number | null;
  changeMembershipLengthBy?: number | null;
  platform?: LinkPlatformInput | null;
  product?: LinkProductInput[] | null;
  isPauseTokenDisabled?: boolean | null;
  additionalTest?: LinkAdditionalTestInput[] | null;
}

export interface CreateQuestionBankCategoryInput {
  title?: string | null;
  isLive?: boolean | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  membershipLevel?: MembershipType | null;
  tabIndex?: number | null;
}

export interface CreateQuestionBankInput {
  questionBankCategory?: LinkQuestionBankCategoryInput | null;
  title?: string | null;
  questions?: LinkQuestionInput[] | null;
  questionIds?: string[] | null;
  order?: number | null;
  isLive?: boolean | null;
  history?: HistoryInput[] | null;
  passage?: PassageInput[] | null;
}

export interface CreateQuestionCategoryInput {
  title?: string | null;
  subjects?: LinkSubjectInput[] | null;
}

export interface CreateQuestionInput {
  title?: string | null;
  questionCategory?: LinkQuestionCategoryInput | null;
  subjects?: LinkSubjectInput[] | null;
  questionAsHtml?: string | null;
  testletScenario?: string | null;
  questionAsPlainText?: string | null;
  questionStem?: string | null;
  answerExplanationAsHtml?: string | null;
  answerExplanationAsPlainText?: string | null;
  order?: number | null;
  type?: QuestionTypeEnum | null;
  isTemplate?: boolean | null;
  templateName?: string | null;
  resetStatistics?: boolean | null;
  history?: HistoryInput[] | null;
  additionalInformation?: string | null;
  showMultipleSelectionLabel?: boolean | null;
  exhibit?: string | null;
  xRay?: string | null;
  photo?: string | null;
  patient?: string | null;
  chiefComplaint?: string | null;
  backgroundAndOrPatientHistory?: string | null;
  dentalHistory?: string | null;
  medicalHistory?: string | null;
  model3D?: string | null;
  currentFinding?: string | null;
  invertQuestionImages?: QuestionInvertTypeEnum | null;
  invertAnswerImages?: QuestionInvertTypeEnum | null;
  invertAnswerExplanationImages?: QuestionInvertTypeEnum | null;
  dentalChart?: string | null;
  periodontalChart?: string | null;
  panoramicChart?: string | null;
  questionPassage?: LinkQuestionPassageInput | null;
  endodonticTable?: any | null;
  orthodonticTable?: any | null;
  periodontalTable?: any | null;
  sourcesAndCredits?: string | null;
  answer: AnswerInput[];
}

export interface CreateQuestionPassageBankInput {
  title?: string | null;
  level?: LevelEnum | null;
  order?: number | null;
  isLive?: boolean | null;
  questionPassagesIds?: string[] | null;
  passageTime?: number | null;
  wpm?: number | null;
  history?: HistoryInput[] | null;
  questionPassages?: LinkQuestionPassageInput[] | null;
  subject?: LinkSubjectInput | null;
}

export interface CreateQuestionPassageInput {
  content?: string | null;
  level?: LevelEnum[] | null;
  title?: string | null;
  isTemplate?: boolean | null;
  templateName?: string | null;
  questions?: CreateQuestionInput[] | null;
  subject?: LinkSubjectInput | null;
  history?: HistoryInput[] | null;
}

export interface CreateRecommendedArticleGroupInput {
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: GroupIcon | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  recommendedArticle?: LinkRecommendedArticleInput[] | null;
}

export interface CreateRecommendedArticleInput {
  name?: string | null;
  link?: string | null;
  recommendedArticleGroup?: LinkRecommendedArticleGroupInput | null;
  description?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
}

export interface CreateRewardInput {
  type?: RewardTypeEnum | null;
  countOfEarnedRewards?: number | null;
  value?: number | null;
  order?: number | null;
  description?: string | null;
  percentage?: number | null;
  isLive?: boolean | null;
  platform?: LinkPlatformInput | null;
}

export interface CreateScreenshotFeedbackInput {
  title?: string | null;
  description?: string | null;
  page?: CMSScreenshotPages | null;
  platform?: LinkPlatformInput | null;
  images?: string[] | null;
}

export interface CreateStrategyGroupInput {
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: string | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  strategy?: LinkStrategyInput[] | null;
}

export interface CreateStrategyInput {
  coverImage?: string | null;
  title?: string | null;
  withWhiteImageBG?: boolean | null;
  description?: string | null;
  featuredArticleDescription?: string | null;
  author?: LinkTeamMemberInput | null;
  fullName?: string | null;
  avatar?: string | null;
  secondaryLine?: string | null;
  content?: string | null;
  tableOfContent?: TableOfContentInput[] | null;
  slug?: string | null;
  membershipLevel?: MembershipType | null;
  order?: number | null;
  strategyGroup?: LinkStrategyGroupInput | null;
}

export interface CreateStudyGuideInput {
  coverImage?: string | null;
  title?: string | null;
  withWhiteImageBG?: boolean | null;
  description?: string | null;
  featuredArticleDescription?: string | null;
  author?: LinkTeamMemberInput | null;
  fullName?: string | null;
  avatar?: string | null;
  score?: string | null;
  guideAsHtml?: string | null;
  tableOfContent?: TableOfContentInput[] | null;
  similarGuides?: string[] | null;
  slug?: string | null;
  icon?: StudyGuideIconEnum | null;
  section?: LinkStudyGuideSectionInput[] | null;
  platform?: LinkPlatformInput | null;
}

export interface CreateStudyGuideSectionInput {
  title?: string | null;
  description?: string | null;
  platform?: LinkPlatformInput | null;
  studyGuideIds?: string[] | null;
  studyGuide?: LinkStudyGuideInput[] | null;
}

export interface CreateStudyNoteGroupInput {
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: GroupIcon | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  studyNote?: LinkStudyNoteInput[] | null;
}

export interface CreateStudyNoteInput {
  name?: string | null;
  isBoosterEnvironment?: boolean | null;
  link?: string | null;
  landingPageDescription?: string | null;
  studyNoteGroup?: LinkStudyNoteGroupInput | null;
  description?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
  isDocumentUpdated?: boolean | null;
}

export interface CreateSuccessStoryInput {
  coverImage?: string | null;
  title?: string | null;
  withWhiteImageBG?: boolean | null;
  description?: string | null;
  featuredArticleDescription?: string | null;
  author?: LinkTeamMemberInput | null;
  fullName?: string | null;
  score?: string | null;
  storyAsHtml?: string | null;
  tableOfContent?: TableOfContentInput[] | null;
  studentsLikeYou?: string[] | null;
  slug?: string | null;
  section?: LinkSuccessStorySectionInput[] | null;
  platform?: LinkPlatformInput | null;
}

export interface CreateSuccessStorySectionInput {
  title?: string | null;
  order?: number | null;
  description?: string | null;
  platform?: LinkPlatformInput | null;
  successStoryIds?: string[] | null;
  successStory?: LinkSuccessStoryInput[] | null;
}

export interface CreateTaskInput {
  title?: string | null;
  type?: TaskTypeEnum | null;
  time?: number | null;
  description?: string | null;
  link?: string | null;
  platform?: LinkPlatformInput | null;
  subject?: LinkSubjectInput | null;
}

export interface CreateTeamMemberInput {
  fullName?: string | null;
  avatar?: string | null;
  degree?: string | null;
  university?: string | null;
  position?: string | null;
  authorPageDescription?: string | null;
  authorPageCredentials?: string | null;
  authorPageHighlights?: string | null;
  videoInstructorDescription?: string | null;
  aboutAuthorDescription?: string | null;
  slug?: string | null;
  link?: LinkTmLinkInput[] | null;
}

export interface CreateTestimonialInput {
  title?: string | null;
  description?: string | null;
  pageWithOrder?: PageWithOrderInput[] | null;
  platform?: LinkPlatformInput | null;
  textFeedback?: LinkTextFeedbackInput[] | null;
}

export interface CreateTextFeedbackInput {
  shortFeedback?: string | null;
  fullFeedback?: string | null;
  student?: CMSStudentInput | null;
  isSelected?: boolean | null;
  order?: number | null;
  testimonial?: LinkTestimonialInput | null;
}

export interface CreateTmLinkInput {
  teamMember?: LinkTeamMemberInput | null;
  order?: number | null;
  platform?: LinkPlatformInput | null;
}

export interface CreateVideoCategoryInput {
  title?: string | null;
  subject?: LinkSubjectInput | null;
  order?: number | null;
  description?: string | null;
  membershipLevel?: MembershipType | null;
  isLive?: boolean | null;
  chapterCompletionTitle?: string | null;
  chapterCompletionDescription?: string | null;
  chapterCompletionBtn?: string | null;
  chapterCompletionBtnUrl?: string | null;
  chapterNotCompletionTitle?: string | null;
  chapterNotCompletionDescription?: string | null;
  chapterNotCompletionBtn?: string | null;
  chapterNotCompletionBtnUrl?: string | null;
  chapterCompletionLive?: boolean | null;
  video?: LinkVideoInput[] | null;
  author?: LinkTeamMemberInput | null;
}

export interface CreateVideoInput {
  title?: string | null;
  membershipLevel?: MembershipType | null;
  order?: number | null;
  link?: string | null;
  videoLength?: number | null;
  isLive?: boolean | null;
  resourseURL?: string | null;
  questionIds?: string[] | null;
  questions?: LinkQuestionInput[] | null;
  history?: HistoryInput[] | null;
  tags?: string[] | null;
}

export interface CreateVideoReviewInput {
  id: string;
  thumbnail?: string | null;
  avatar?: string | null;
  fullName?: string | null;
  description?: string | null;
  videoReviewSection?: LinkVideoReviewSectionInput | null;
  videoFileName: string;
}

export interface DailyGoalStreakInput {
  platform: PlatformName;
  isDailyGoalDone: boolean;
  dailyGoalStreak: number;
}

export interface DailyWarmupStatsInput {
  platform: PlatformName;
  isDailyWarmupDone: boolean;
  dailyWarmupStreak: number;
}

export interface DentalSchoolDetailsInput {
  title?: string | null;
  description?: string | null;
  table?: any | null;
}

export interface DentalSchoolLocationOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface DentalSchoolLocationQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: DentalSchoolLocationWhere | null;
  order?: DentalSchoolLocationOrder | null;
}

export interface DentalSchoolLocationWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  description?: string | null;
  schoolLocationType?: SchoolLocationTypeEnum | null;
  platform?: LinkPlatformInput | null;
  dentalSchoolIds?: string[] | null;
  isOptometry?: boolean | null;
  dentalSchool?: LinkDentalSchoolInput[] | null;
}

export interface DentalSchoolOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface DentalSchoolQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: DentalSchoolWhere | null;
  order?: DentalSchoolOrder | null;
}

export interface DentalSchoolWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  image?: string | null;
  description?: string | null;
  isFeaturedExperts?: boolean | null;
  slug?: string | null;
  infoFirstColumn?: string[] | null;
  infoSecondColumn?: string[] | null;
  isOptometry?: boolean | null;
  details?: DentalSchoolDetailsInput[] | null;
  location?: LinkDentalSchoolLocationInput[] | null;
  platform?: LinkPlatformInput | null;
}

export interface EmailConfigInput {
  isDisabledForAdmins?: boolean | null;
  isDisabledForUsers?: boolean | null;
  is2DaysPriorEnabled?: boolean | null;
  is7DaysPriorEnabled?: boolean | null;
}

export interface EntityDateRangeFilterInput {
  from?: any | null;
  to?: any | null;
}

export interface ExamCountdownInput {
  platform: PlatformName;
  countdown?: any | null;
}

export interface ExtensionExamOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface ExtensionExamQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: ExtensionExamWhere | null;
  order?: ExtensionExamOrder | null;
}

export interface ExtensionExamWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  examId?: string | null;
  message?: string | null;
  order?: number | null;
  contentPackageId?: string | null;
  showSolution?: boolean | null;
  showExam?: boolean | null;
}

export interface FaqOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
}

export interface FaqQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: FaqWhere | null;
  order?: FaqOrder | null;
}

export interface FaqWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  question?: string | null;
  answerAsHtml?: string | null;
  page?: FaqPages | null;
  order?: number | null;
  type?: FaqTypeEnum | null;
  platform?: FindByPlatformInput | null;
}

export interface FindByPlatformInput {
  id?: string | null;
  slug?: string | null;
}

export interface FindByRewardInput {
  id?: string | null;
  platform?: FindByPlatformInput | null;
}

export interface FindInPersonMockResultInput {
  practiceTest: LinkPracticeTestInput;
  university?: DentalSchoolsEnum | null;
  createdAt?: EntityDateRangeFilterInput | null;
}

export interface FlashCardGroupOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
  flashCardsOrder?: OrderDirection | null;
}

export interface FlashCardGroupQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: FlashCardGroupWhere | null;
  order?: FlashCardGroupOrder | null;
}

export interface FlashCardGroupWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: GroupIcon | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  flashCard?: LinkFlashCardInput[] | null;
}

export interface FlashCardOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface FlashCardQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: FlashCardWhere | null;
  order?: FlashCardOrder | null;
}

export interface FlashCardWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  name?: string | null;
  link?: string | null;
  flashCardGroup?: LinkFlashCardGroupInput | null;
  description?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
  subject?: LinkSubjectInput | null;
}

export interface GameChallengeOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface GameChallengeQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: GameChallengeWhere | null;
  order?: GameChallengeOrder | null;
}

export interface GameChallengeWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  type?: GameChallengeTypeEnum | null;
  description?: string | null;
  order?: number | null;
  isActive?: boolean | null;
  platform?: LinkPlatformInput | null;
}

export interface HistoryInput {
  updatedAt?: any | null;
  updatedBy?: string | null;
}

export interface InfluencerHubOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface InfluencerHubQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: InfluencerHubWhere | null;
  order?: InfluencerHubOrder | null;
}

export interface InfluencerHubWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  name?: string | null;
  coverImage?: string | null;
  description?: string | null;
  influencerPlatform?: InfluencerPlatformEnum | null;
  socialLink?: string | null;
  influencerType?: InfluencerTypeEnum | null;
  order?: number | null;
}

export interface InstitutionalCodesOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  studentsCount?: OrderDirection | null;
  facultyMembersCount?: OrderDirection | null;
  remainingUserCodesCount?: OrderDirection | null;
}

export interface InstitutionalCodesQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: InstitutionalCodesWhere | null;
  order?: InstitutionalCodesOrder | null;
}

export interface InstitutionalCodesWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  university?: DentalSchoolsEnum | null;
  cohort?: FacultyModeCohortYearEnum | null;
  platform?: LinkPlatformInput | null;
}

export interface IpLogOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface IpLogQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: IpLogWhere | null;
  order?: IpLogOrder | null;
}

export interface IpLogWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  ip?: string | null;
  browserId?: string | null;
  userAgent?: string | null;
  city?: string | null;
  region?: string | null;
  deviceType?: DeviceTypeEnum | null;
  user?: LinkUserInput | null;
}

export interface KeysTeamMemberInput {
  id?: string | null;
  slug: string;
}

export interface LinkAdditionalTestInput {
  id: string;
}

export interface LinkAiTestInput {
  id: string;
}

export interface LinkAiTestQuestionInput {
  id: string;
}

export interface LinkAnswerInput {
  id: string;
}

export interface LinkCasperFullLengthTestInput {
  id: string;
}

export interface LinkCheatSheetGroupInput {
  id: string;
}

export interface LinkCheatSheetInput {
  id: string;
}

export interface LinkDentalSchoolInput {
  id: string;
}

export interface LinkDentalSchoolLocationInput {
  id: string;
}

export interface LinkExtensionExamInput {
  id: string;
}

export interface LinkExtensionExamSectionInput {
  id: string;
}

export interface LinkFaqInput {
  id: string;
}

export interface LinkFlashCardGroupInput {
  id: string;
}

export interface LinkFlashCardInput {
  id: string;
}

export interface LinkFullLengthTestInput {
  id: string;
}

export interface LinkInstitutionalCodesInput {
  id: string;
}

export interface LinkOrderDirection {
  order?: OrderDirection | null;
}

export interface LinkPassageInput {
  id: string;
}

export interface LinkPlatformInput {
  id: string;
}

export interface LinkPracticeTestCategoryInput {
  id: string;
}

export interface LinkPracticeTestInput {
  id: string;
}

export interface LinkPracticeTestResultInput {
  id: string;
}

export interface LinkProductInput {
  id: string;
}

export interface LinkPromocodeInput {
  id: string;
}

export interface LinkQuestionBankCategoryInput {
  id: string;
}

export interface LinkQuestionBankInput {
  id: string;
}

export interface LinkQuestionCategoryInput {
  id: string;
}

export interface LinkQuestionInput {
  id: string;
}

export interface LinkQuestionPassageInput {
  id: string;
}

export interface LinkRecommendedArticleGroupInput {
  id: string;
}

export interface LinkRecommendedArticleInput {
  id: string;
}

export interface LinkRewardInput {
  id: string;
}

export interface LinkStrategyGroupInput {
  id: string;
}

export interface LinkStrategyInput {
  id: string;
}

export interface LinkStudyGuideInput {
  id: string;
}

export interface LinkStudyGuideSectionInput {
  id: string;
}

export interface LinkStudyNoteGroupInput {
  id: string;
}

export interface LinkStudyNoteInput {
  id: string;
}

export interface LinkSubjectInput {
  id: string;
}

export interface LinkSuccessStoryInput {
  id: string;
}

export interface LinkSuccessStorySectionInput {
  id: string;
}

export interface LinkTaskInput {
  id: string;
}

export interface LinkTeamMemberInput {
  id: string;
}

export interface LinkTestimonialInput {
  id: string;
}

export interface LinkTextFeedbackInput {
  id: string;
}

export interface LinkTmLinkInput {
  id: string;
}

export interface LinkUserAnswerInput {
  id: string;
}

export interface LinkUserInput {
  id: string;
}

export interface LinkVideoInput {
  id: string;
}

export interface LinkVideoReviewSectionInput {
  id: string;
}

export interface MembershipInput {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  type: MembershipType;
  duration?: string | null;
  status?: MembershipStatus | null;
  pausedAt?: any | null;
  expiresTo?: any | null;
  startDate?: any | null;
  isExtended: boolean;
  extensionType?: ExtensionType | null;
  extensionDuration?: string | null;
  pauseTokensCount: number;
  pauseTokensUsed: number;
  usedPromocode?: string | null;
  subscriptionId?: string | null;
  subscriptionStatus?: SubscriptionStatus | null;
  cancellationReason?: CancellationReasonEnum | null;
  cancellationReasonDescription?: string | null;
  cancellationComment?: string | null;
  cancellationDate?: any | null;
  additionalTestsSubjectIds?: string[] | null;
  order?: number | null;
  user: LinkUserInput;
}

export interface MembershipLogOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface MembershipLogQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: MembershipLogWhere | null;
  order?: MembershipLogOrder | null;
}

export interface MembershipLogWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  platform?: PlatformName | null;
  log?: string | null;
  user?: LinkUserInput | null;
}

export interface NotificationInput {
  platform: PlatformName;
  hours?: number | null;
}

export interface OnboardingDataInput {
  platform: PlatformName;
  isOnboarded: boolean;
  isViewedModal: boolean;
}

export interface PTResultWithoutHistory {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  resultPercantage: number;
  resultTextAsHtml: string;
  DATScore: number;
  platform?: LinkPlatformInput | null;
}

export interface PageWithOrderInput {
  page?: CMSBoosterPages | null;
  order?: number | null;
}

export interface PassageInput {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title: string;
  category?: PassageTypeEnum | null;
  subCategory?: PassageSubCategoryEnum | null;
  startQuestion: number;
  endQuestion: number;
  content: string;
  watchPassageWalkthrough?: string | null;
  reference?: string | null;
  invertContentImages: QuestionInvertTypeEnum;
}

export interface PauseTokenOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface PauseTokenQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: PauseTokenWhere | null;
  order?: PauseTokenOrder | null;
}

export interface PauseTokenWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  name?: string | null;
  amount?: number | null;
  description?: string | null;
  status?: ProductStatus | null;
  price?: number | null;
  active?: number | null;
  order?: number | null;
  isMostPopular?: boolean | null;
  ligthModeImageUrl?: string | null;
  darkModeImageUrl?: string | null;
  platform?: LinkPlatformInput | null;
  stripeProductId?: string | null;
}

export interface PlatformOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  isActive?: OrderDirection | null;
}

export interface PlatformQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: PlatformWhere | null;
  order?: PlatformOrder | null;
}

export interface PlatformWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: PlatformName | null;
  category?: PlatformCategory | null;
  description?: string | null;
  shortDescription?: string | null;
  slug?: string | null;
  isActive?: boolean | null;
  order?: number | null;
}

export interface PracticeTestCategoryOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
}

export interface PracticeTestCategoryQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: PracticeTestCategoryWhere | null;
  order?: PracticeTestCategoryOrder | null;
}

export interface PracticeTestCategoryWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  isLive?: boolean | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  membershipLevel?: MembershipType | null;
}

export interface PracticeTestOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
}

export interface PracticeTestQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: PracticeTestWhere | null;
  order?: PracticeTestOrder | null;
}

export interface PracticeTestResultInput {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  resultPercantage: number;
  resultTextAsHtml: string;
  DATScore: number;
  history?: HistoryInput[] | null;
  platform?: LinkPlatformInput | null;
}

export interface PracticeTestResultOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface PracticeTestResultQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: PracticeTestResultWhere | null;
  order?: PracticeTestResultOrder | null;
}

export interface PracticeTestResultWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  resultPercantage?: number | null;
  resultTextAsHtml?: string | null;
  DATScore?: number | null;
  history?: HistoryInput[] | null;
  platform?: LinkPlatformInput | null;
}

export interface PracticeTestSubjectOrder {
  id?: OrderDirection | null;
  tabName?: OrderDirection | null;
}

export interface PracticeTestSubjectPlatformUserStatsWhere {
  id?: string | null;
}

export interface PracticeTestSubjectUserStatsWhere {
  id?: string | null;
  platform?: PracticeTestSubjectPlatformUserStatsWhere | null;
}

export interface PracticeTestTitleOrder {
  title?: OrderDirection | null;
  subject?: PracticeTestSubjectOrder | null;
  type?: OrderDirection | null;
}

export interface PracticeTestUserStatsWhere {
  id?: string | null;
  subject?: PracticeTestSubjectUserStatsWhere | null;
  type?: PracticeTestTypeEnum | null;
  isNotReadingQBank?: boolean | null;
}

export interface PracticeTestWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  isLive?: boolean | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  duration?: number | null;
  questions?: LinkQuestionInput[] | null;
  questionIds?: string[] | null;
  timeRecord?: TimeRecordEnum | null;
  membershipLevel?: MembershipType | null;
  pageDescriptionAsHtml?: string | null;
  introAsHtml?: string | null;
  type?: PracticeTestTypeEnum | null;
  passage?: LinkPassageInput[] | null;
  practiceTestCategory?: LinkPracticeTestCategoryInput | null;
  history?: HistoryInput[] | null;
  breaksSections?: BreakSectionsInput[] | null;
  testResult?: LinkPracticeTestResultInput[] | null;
  slug?: string | null;
  university?: DentalSchoolsEnum | null;
}

export interface ProductOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  price?: OrderDirection | null;
}

export interface ProductQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: ProductWhere | null;
  order?: ProductOrder | null;
}

export interface ProductWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  stripeProductId?: string | null;
  name?: string | null;
  status?: ProductStatus | null;
  duration?: string | null;
  price?: number | null;
  type?: ProductTypeEnum | null;
  isExtension?: boolean | null;
  isSubscription?: boolean | null;
  order?: number | null;
  platform?: LinkPlatformInput | null;
  promocode?: LinkPromocodeInput[] | null;
}

export interface PromocodeHistoryOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface PromocodeHistoryQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: PromocodeHistoryWhere | null;
  order?: PromocodeHistoryOrder | null;
}

export interface PromocodeHistoryWhere {
  promocode: LinkPromocodeInput;
  displayBy?: PromocodeHistoryDisplayByTypeEnum | null;
}

export interface PromocodeOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  alreadyUsed?: OrderDirection | null;
}

export interface PromocodeQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: PromocodeWhere | null;
  order?: PromocodeOrder | null;
}

export interface PromocodeWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  name?: string | null;
  description?: string | null;
  code?: string | null;
  type?: PromocodeTypeEnum | null;
  amount?: number | null;
  expirationDate?: any | null;
  status?: PromocodeStatusEnum | null;
  maxUses?: number | null;
  changeMembershipLengthBy?: number | null;
  platform?: LinkPlatformInput | null;
  product?: LinkProductInput[] | null;
  isPauseTokenDisabled?: boolean | null;
  additionalTest?: LinkAdditionalTestInput[] | null;
}

export interface QuestionBankCategoryOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
}

export interface QuestionBankCategoryQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: QuestionBankCategoryWhere | null;
  order?: QuestionBankCategoryOrder | null;
}

export interface QuestionBankCategoryWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  isLive?: boolean | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  membershipLevel?: MembershipType | null;
  tabIndex?: number | null;
}

export interface QuestionCategoryOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface QuestionCategoryQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: QuestionCategoryWhere | null;
  order?: QuestionCategoryOrder | null;
}

export interface QuestionCategoryWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  subjects?: LinkSubjectInput[] | null;
}

export interface QuestionOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface QuestionPassageBankOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface QuestionPassageBankQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: QuestionPassageBankWhere | null;
  order?: QuestionPassageBankOrder | null;
}

export interface QuestionPassageBankWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  level?: LevelEnum | null;
  order?: number | null;
  isLive?: boolean | null;
  questionPassagesIds?: string[] | null;
  passageTime?: number | null;
  wpm?: number | null;
  history?: HistoryInput[] | null;
  questionPassages?: LinkQuestionPassageInput[] | null;
  subject?: LinkSubjectInput | null;
}

export interface QuestionPassageOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface QuestionPassageQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: QuestionPassageWhere | null;
  order?: QuestionPassageOrder | null;
}

export interface QuestionPassageWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  content?: string | null;
  level?: LevelEnum[] | null;
  title?: string | null;
  isTemplate?: boolean | null;
  templateName?: string | null;
  questions?: CreateQuestionInput[] | null;
  subject?: LinkSubjectInput | null;
  history?: HistoryInput[] | null;
  excludeIds?: string[] | null;
}

export interface QuestionQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: QuestionWhere | null;
  order?: QuestionOrder | null;
}

export interface QuestionWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  questionCategory?: LinkQuestionCategoryInput | null;
  questionAsHtml?: string | null;
  testletScenario?: string | null;
  questionAsPlainText?: string | null;
  answer?: LinkAnswerInput[] | null;
  questionStem?: string | null;
  answerExplanationAsHtml?: string | null;
  answerExplanationAsPlainText?: string | null;
  order?: number | null;
  type?: QuestionTypeEnum | null;
  isTemplate?: boolean | null;
  templateName?: string | null;
  resetStatistics?: boolean | null;
  history?: HistoryInput[] | null;
  additionalInformation?: string | null;
  showMultipleSelectionLabel?: boolean | null;
  exhibit?: string | null;
  xRay?: string | null;
  photo?: string | null;
  patient?: string | null;
  chiefComplaint?: string | null;
  backgroundAndOrPatientHistory?: string | null;
  dentalHistory?: string | null;
  medicalHistory?: string | null;
  model3D?: string | null;
  currentFinding?: string | null;
  invertQuestionImages?: QuestionInvertTypeEnum | null;
  invertAnswerImages?: QuestionInvertTypeEnum | null;
  invertAnswerExplanationImages?: QuestionInvertTypeEnum | null;
  dentalChart?: string | null;
  periodontalChart?: string | null;
  panoramicChart?: string | null;
  questionPassage?: LinkQuestionPassageInput | null;
  endodonticTable?: any | null;
  orthodonticTable?: any | null;
  periodontalTable?: any | null;
  sourcesAndCredits?: string | null;
  subject?: LinkSubjectInput | null;
  platform?: LinkPlatformInput | null;
  questionBank?: LinkQuestionBankInput | null;
  practiceTest?: LinkPracticeTestInput | null;
  excludeIds?: string[] | null;
  fullLengthTest?: LinkFullLengthTestInput | null;
  willUsedIn?: QuestionLocationTypeEnum | null;
  types?: QuestionTypeEnum[] | null;
  questionBankIds?: string[] | null;
}

export interface RecommendedArticleGroupOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
  recommendedArticleOrder?: OrderDirection | null;
}

export interface RecommendedArticleGroupQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: RecommendedArticleGroupWhere | null;
  order?: RecommendedArticleGroupOrder | null;
}

export interface RecommendedArticleGroupWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: GroupIcon | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  recommendedArticle?: LinkRecommendedArticleInput[] | null;
}

export interface RecommendedArticleOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface RecommendedArticleQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: RecommendedArticleWhere | null;
  order?: RecommendedArticleOrder | null;
}

export interface RecommendedArticleWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  name?: string | null;
  link?: string | null;
  recommendedArticleGroup?: LinkRecommendedArticleGroupInput | null;
  description?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
  subject?: LinkSubjectInput | null;
}

export interface ReportByCategoryInput {
  id?: string | null;
  totalAnswersCount: number;
  timeSpentInPercentage: number;
  timeSpent: number;
  questionCategoryName: string;
  questionIds: string[];
  correctAnswersCount: number;
  subjectTabName?: string | null;
  sectionIndex?: number | null;
}

export interface ReportByPassageInput {
  id?: string | null;
  totalAnswersCount: number;
  timeSpentInPercentage: number;
  timeSpent: number;
  order: number;
  passageCategory: PassageTypeEnum;
  passageSubCategory: PassageSubCategoryEnum;
  questionIds: string[];
  correctAnswersCount: number;
}

export interface RewardOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface RewardQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: RewardWhere | null;
  order?: RewardOrder | null;
}

export interface RewardWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  type?: RewardTypeEnum | null;
  countOfEarnedRewards?: number | null;
  value?: number | null;
  order?: number | null;
  description?: string | null;
  percentage?: number | null;
  isLive?: boolean | null;
  platform?: LinkPlatformInput | null;
}

export interface S3FileInput {
  fileName?: string | null;
  path?: string | null;
  contentType?: string | null;
  method?: string | null;
  isPDF?: boolean | null;
}

export interface SearchInput {
  query?: string | null;
  type?: SearchTypeEnum | null;
}

export interface SendEmailInput {
  data?: string | null;
  email: string[];
  templateName: string;
}

export interface StrategyGroupOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface StrategyGroupQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: StrategyGroupWhere | null;
  order?: StrategyGroupOrder | null;
}

export interface StrategyGroupWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: string | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  strategy?: LinkStrategyInput[] | null;
}

export interface StrategyOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface StrategyQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: StrategyWhere | null;
  order?: StrategyOrder | null;
}

export interface StrategyWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  coverImage?: string | null;
  title?: string | null;
  withWhiteImageBG?: boolean | null;
  description?: string | null;
  featuredArticleDescription?: string | null;
  author?: LinkTeamMemberInput | null;
  fullName?: string | null;
  avatar?: string | null;
  secondaryLine?: string | null;
  content?: string | null;
  tableOfContent?: TableOfContentInput[] | null;
  slug?: string | null;
  membershipLevel?: MembershipType | null;
  order?: number | null;
  strategyGroup?: LinkStrategyGroupInput | null;
}

export interface StripeProductInput {
  id: string;
  name?: string | null;
  status?: string | null;
  duration?: string | null;
  price?: number | null;
  originalPrice?: number | null;
  description?: string | null;
  image?: string | null;
}

export interface StudyGuideOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface StudyGuideQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: StudyGuideWhere | null;
  order?: StudyGuideOrder | null;
}

export interface StudyGuideSectionOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface StudyGuideSectionQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: StudyGuideSectionWhere | null;
  order?: StudyGuideSectionOrder | null;
}

export interface StudyGuideSectionWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  description?: string | null;
  platform?: LinkPlatformInput | null;
  studyGuideIds?: string[] | null;
  studyGuide?: LinkStudyGuideInput[] | null;
}

export interface StudyGuideWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  coverImage?: string | null;
  title?: string | null;
  withWhiteImageBG?: boolean | null;
  description?: string | null;
  featuredArticleDescription?: string | null;
  fullName?: string | null;
  avatar?: string | null;
  score?: string | null;
  guideAsHtml?: string | null;
  tableOfContent?: TableOfContentInput[] | null;
  similarGuides?: string[] | null;
  slug?: string | null;
  icon?: StudyGuideIconEnum | null;
  section?: LinkStudyGuideSectionInput[] | null;
  platform?: LinkPlatformInput | null;
  author?: KeysTeamMemberInput | null;
  withSection?: boolean | null;
}

export interface StudyNoteGroupOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
  studyNotesOrder?: OrderDirection | null;
}

export interface StudyNoteGroupQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: StudyNoteGroupWhere | null;
  order?: StudyNoteGroupOrder | null;
}

export interface StudyNoteGroupWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: GroupIcon | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  studyNote?: LinkStudyNoteInput[] | null;
}

export interface StudyNoteOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface StudyNoteQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: StudyNoteWhere | null;
  order?: StudyNoteOrder | null;
}

export interface StudyNoteWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  name?: string | null;
  isBoosterEnvironment?: boolean | null;
  link?: string | null;
  landingPageDescription?: string | null;
  studyNoteGroup?: LinkStudyNoteGroupInput | null;
  description?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
  isDocumentUpdated?: boolean | null;
  subject?: LinkSubjectInput | null;
}

export interface StudyScheduleDataInput {
  platform: PlatformName;
  isStudySchedule: boolean;
}

export interface StudyToolsDescriptionOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface StudyToolsDescriptionQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: StudyToolsDescriptionWhere | null;
  order?: StudyToolsDescriptionOrder | null;
}

export interface StudyToolsDescriptionWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  page?: string | null;
  description?: string | null;
  platform?: LinkPlatformInput | null;
}

export interface SubjectAddTestsFilter {
  id?: string | null;
  platform?: FindByPlatformInput | null;
}

export interface SubjectOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
}

export interface SubjectQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: SubjectWhere | null;
  order?: SubjectOrder | null;
}

export interface SubjectWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  platform?: LinkPlatformInput | null;
  icon?: string | null;
  tabName?: string | null;
  type?: SubjectEnumType | null;
  slug?: string | null;
  order?: number | null;
  isHidden?: boolean | null;
  questionBankDescription?: string[] | null;
}

export interface SuccessStoryFilterWhere {
  id?: string | null;
  platform?: FindByPlatformInput | null;
}

export interface SuccessStoryOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface SuccessStoryQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: SuccessStoryWhere | null;
  order?: SuccessStoryOrder | null;
}

export interface SuccessStorySectionOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface SuccessStorySectionQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: SuccessStorySectionWhere | null;
  order?: SuccessStorySectionOrder | null;
}

export interface SuccessStorySectionWhere {
  id?: string | null;
  title?: string | null;
  order?: number | null;
  description?: string | null;
  platform?: LinkPlatformInput | null;
  successStoryIds?: string[] | null;
  successStory?: SuccessStoryFilterWhere | null;
}

export interface SuccessStoryWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  coverImage?: string | null;
  title?: string | null;
  withWhiteImageBG?: boolean | null;
  description?: string | null;
  featuredArticleDescription?: string | null;
  author?: KeysTeamMemberInput | null;
  fullName?: string | null;
  score?: string | null;
  storyAsHtml?: string | null;
  tableOfContent?: TableOfContentInput[] | null;
  studentsLikeYou?: string[] | null;
  slug?: string | null;
  section?: LinkSuccessStorySectionInput[] | null;
  platform?: LinkPlatformInput | null;
  withSection?: boolean | null;
}

export interface TableOfContentInput {
  title: string;
  slug: string;
}

export interface TaskOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface TaskQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: TaskWhere | null;
  order?: TaskOrder | null;
}

export interface TaskWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  type?: TaskTypeEnum | null;
  time?: number | null;
  description?: string | null;
  link?: string | null;
  platform?: LinkPlatformInput | null;
  subject?: LinkSubjectInput | null;
  isAllSubjects?: boolean | null;
  excludeIds?: string[] | null;
}

export interface TeamMemberOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  link?: LinkOrderDirection | null;
}

export interface TeamMemberQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: TeamMemberWhere | null;
  order?: TeamMemberOrder | null;
}

export interface TeamMemberWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  fullName?: string | null;
  avatar?: string | null;
  degree?: string | null;
  university?: string | null;
  position?: string | null;
  authorPageDescription?: string | null;
  authorPageCredentials?: string | null;
  authorPageHighlights?: string | null;
  videoInstructorDescription?: string | null;
  aboutAuthorDescription?: string | null;
  slug?: string | null;
  link?: TeamMembersLinkWhere | null;
}

export interface TeamMembersLinkWhere {
  id?: string | null;
  order?: number | null;
  platform?: FindByPlatformInput | null;
}

export interface TestimonialOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface TestimonialQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: TestimonialWhere | null;
  order?: TestimonialOrder | null;
}

export interface TestimonialWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  description?: string | null;
  textFeedback?: LinkTextFeedbackInput[] | null;
  pageWithOrder?: PageWithOrderInput | null;
  platform?: FindByPlatformInput | null;
}

export interface TextFeedbackOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
}

export interface TextFeedbackQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: TextFeedbackWhere | null;
  order?: TextFeedbackOrder | null;
}

export interface TextFeedbackWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  shortFeedback?: string | null;
  fullFeedback?: string | null;
  student?: CMSStudentInput | null;
  isSelected?: boolean | null;
  order?: number | null;
  testimonial?: LinkTestimonialInput | null;
}

export interface TmLinkOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface TmLinkQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: TmLinkWhere | null;
  order?: TmLinkOrder | null;
}

export interface TmLinkWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  teamMember?: LinkTeamMemberInput | null;
  order?: number | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateAchievementInput {
  id?: string | null;
  isLive?: boolean | null;
  type?: AchievementTypeEnum | null;
  amountRequired?: number | null;
  order?: number | null;
  awardType?: AwardTypeEnum | null;
  awardTypeValue?: number | null;
  description?: string | null;
  level?: number | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateAdditionalTestInput {
  id?: string | null;
  name?: string | null;
  type?: AdditionalTestTypeEnum | null;
  subject?: LinkSubjectInput | null;
  description?: string | null;
  practiceTests?: LinkPracticeTestInput[] | null;
  price?: number | null;
  status?: ProductStatus | null;
  order?: number | null;
  isMostPopular?: boolean | null;
  ligthModeImageUrl?: string | null;
  darkModeImageUrl?: string | null;
  promocode?: LinkPromocodeInput[] | null;
}

export interface UpdateAdmissionExpertInput {
  id?: string | null;
  page?: ServicePageTypeEnum | null;
  avatar?: string | null;
  name?: string | null;
  degree?: string | null;
  description?: string | null;
  email?: string | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateAdmissionServiceInput {
  id?: string | null;
  page?: ServicePageTypeEnum | null;
  category?: ServiceCategoryTypeEnum | null;
  title?: string | null;
  isPopular?: boolean | null;
  price?: number | null;
  originalPrice?: number | null;
  feature?: string[] | null;
  paymentLink?: string | null;
  description?: string | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateAiTestInput {
  id?: string | null;
  title?: string | null;
  type?: AITestTypeEnum | null;
  responseType?: AITestResponseTypeEnum | null;
  description?: string | null;
  contextVideoUrl?: string | null;
  contextText?: string | null;
  videoText?: string | null;
  order?: number | null;
  isLive?: boolean | null;
  membershipLevel?: MembershipType | null;
  casperFullLengthTest?: LinkCasperFullLengthTestInput | null;
}

export interface UpdateAiTestQuestionInput {
  id?: string | null;
  bestResponseVideoUrl?: string | null;
  bestResponseText?: string | null;
  isLive?: boolean | null;
}

export interface UpdateAiTestTrainingDataInput {
  id?: string | null;
  answerText?: string | null;
  quartile?: number | null;
  quartileExplanation?: string | null;
  responseFeedback?: string | null;
  isFromAI?: boolean | null;
  userEmail?: string | null;
  testType?: AITestTypeEnum | null;
  question?: LinkAiTestQuestionInput | null;
}

export interface UpdateCanadianDatTipInput {
  id?: string | null;
  title?: CanadianDatTipsTypeEnum | null;
  description?: string | null;
}

export interface UpdateCarsQuestionInput {
  questions?: UpdateQuestionInput[] | null;
  passage: UpdateQuestionPassage;
}

export interface UpdateCasperFullLengthTestInput {
  id?: string | null;
  description?: string | null;
  title?: string | null;
  membershipLevel?: MembershipType | null;
  aiTests?: LinkAiTestInput[] | null;
}

export interface UpdateChapterNotesInput {
  id?: string | null;
  title?: string | null;
  link?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
}

export interface UpdateCheatSheetGroupInput {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: GroupIcon | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  cheatSheet?: LinkCheatSheetInput[] | null;
}

export interface UpdateCheatSheetInput {
  id?: string | null;
  cheatSheetGroup?: LinkCheatSheetGroupInput | null;
  isBoosterEnvironment?: boolean | null;
  title?: string | null;
  description?: string | null;
  link?: string | null;
  landingPageDescription?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
  isDocumentUpdated?: boolean | null;
}

export interface UpdateClassroomTabInput {
  id?: string | null;
  subject?: LinkSubjectInput | null;
  tabName?: string | null;
  tabEnum?: ClassroomTabEnum | null;
  order?: number | null;
  isHidden?: boolean | null;
}

export interface UpdateComparisonTableInput {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  boosterPremiumPrice?: string | null;
  bootcampProPrice?: string | null;
  features?: any[] | null;
  disclaimerDescription?: string | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateCrashCourseInput {
  id?: string | null;
  courseName?: string | null;
  order?: number | null;
  author?: LinkTeamMemberInput[] | null;
  price?: string | null;
  startDate?: any | null;
  topics?: string[] | null;
  link?: string | null;
  additionalInfo?: string | null;
  subject?: LinkSubjectInput | null;
}

export interface UpdateDentalSchoolInput {
  id?: string | null;
  title?: string | null;
  image?: string | null;
  description?: string | null;
  isFeaturedExperts?: boolean | null;
  slug?: string | null;
  infoFirstColumn?: string[] | null;
  infoSecondColumn?: string[] | null;
  isOptometry?: boolean | null;
  details?: DentalSchoolDetailsInput[] | null;
  location?: LinkDentalSchoolLocationInput[] | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateDentalSchoolLocationInput {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  schoolLocationType?: SchoolLocationTypeEnum | null;
  platform?: LinkPlatformInput | null;
  dentalSchoolIds?: string[] | null;
  isOptometry?: boolean | null;
  dentalSchool?: LinkDentalSchoolInput[] | null;
}

export interface UpdateEmailTemplateInput {
  id?: string | null;
  title?: string | null;
  type?: EmailTemplateTypeEnum | null;
  subject?: string | null;
  emailAsHtml?: string | null;
  emailAsPlainText?: string | null;
  config?: EmailConfigInput | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateExtensionExamInput {
  id?: string | null;
  title?: string | null;
  examId?: string | null;
  message?: string | null;
  order?: number | null;
  contentPackageId?: string | null;
  showSolution?: boolean | null;
  showExam?: boolean | null;
}

export interface UpdateExtensionExamSectionInput {
  id?: string | null;
  title?: string | null;
  order?: number | null;
  sectionId?: string | null;
  examId?: string | null;
  showSolution?: boolean | null;
  extensionExam?: LinkExtensionExamInput | null;
}

export interface UpdateExtensionInput {
  status?: ExtensionStatusEnum | null;
  message?: string | null;
}

export interface UpdateExtensionPassageInput {
  id?: string | null;
  passageId?: string | null;
  content?: string | null;
  sectionId?: string | null;
  videoWalkthrough?: string | null;
  extensionExamSection?: LinkExtensionExamSectionInput | null;
}

export interface UpdateExtensionQuestionInput {
  id?: string | null;
  questionId?: string | null;
  question?: string | null;
  questionContent?: string | null;
  optionsCount?: number | null;
  correctOption?: string | null;
  passageId?: string | null;
  sectionId?: string | null;
  mainSolution?: string | null;
  mainVideoSolution?: string | null;
  difficulty?: ExtensionQuestionDifficultyEnum | null;
  order?: number | null;
  answerSolution?: string[] | null;
  answer?: string[] | null;
  history?: HistoryInput[] | null;
  extensionExamSection?: LinkExtensionExamSectionInput | null;
  extensionPassage?: LinkExtensionExamSectionInput | null;
}

export interface UpdateFlashCardGroupInput {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: GroupIcon | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  flashCard?: LinkFlashCardInput[] | null;
}

export interface UpdateFlashCardInput {
  id?: string | null;
  name?: string | null;
  link?: string | null;
  flashCardGroup?: LinkFlashCardGroupInput | null;
  description?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
}

export interface UpdateGameChallengeInput {
  id?: string | null;
  type?: GameChallengeTypeEnum | null;
  description?: string | null;
  order?: number | null;
  isActive?: boolean | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateInfluencerHubInput {
  id?: string | null;
  name?: string | null;
  coverImage?: string | null;
  description?: string | null;
  influencerPlatform?: InfluencerPlatformEnum | null;
  socialLink?: string | null;
  influencerType?: InfluencerTypeEnum | null;
  order?: number | null;
}

export interface UpdateMembershipInput {
  id?: string | null;
  type?: MembershipType | null;
  duration?: string | null;
  status?: MembershipStatus | null;
  pausedAt?: any | null;
  expiresTo?: any | null;
  startDate?: any | null;
  isExtended?: boolean | null;
  extensionType?: ExtensionType | null;
  extensionDuration?: string | null;
  pauseTokensCount?: number | null;
  pauseTokensUsed?: number | null;
  usedPromocode?: string | null;
  subscriptionId?: string | null;
  subscriptionStatus?: SubscriptionStatus | null;
  cancellationReason?: CancellationReasonEnum | null;
  cancellationReasonDescription?: string | null;
  cancellationComment?: string | null;
  cancellationDate?: any | null;
  additionalTestsSubjectIds?: string[] | null;
  order?: number | null;
  user?: LinkUserInput | null;
}

export interface UpdatePauseTokenInput {
  id?: string | null;
  name?: string | null;
  amount?: number | null;
  description?: string | null;
  status?: ProductStatus | null;
  price?: number | null;
  active?: number | null;
  order?: number | null;
  isMostPopular?: boolean | null;
  ligthModeImageUrl?: string | null;
  darkModeImageUrl?: string | null;
  platform?: LinkPlatformInput | null;
  stripeProductId?: string | null;
}

export interface UpdatePracticeTestCategoryInput {
  id?: string | null;
  title?: string | null;
  isLive?: boolean | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  membershipLevel?: MembershipType | null;
}

export interface UpdatePracticeTestInput {
  id?: string | null;
  title?: string | null;
  isLive?: boolean | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  duration?: number | null;
  questions?: LinkQuestionInput[] | null;
  questionIds?: string[] | null;
  timeRecord?: TimeRecordEnum | null;
  membershipLevel?: MembershipType | null;
  pageDescriptionAsHtml?: string | null;
  introAsHtml?: string | null;
  type?: PracticeTestTypeEnum | null;
  practiceTestCategory?: LinkPracticeTestCategoryInput | null;
  history?: HistoryInput[] | null;
  breaksSections?: BreakSectionsInput[] | null;
  slug?: string | null;
  university?: DentalSchoolsEnum | null;
  testResult?: PracticeTestResultInput[] | null;
  passage?: PassageInput[] | null;
}

export interface UpdatePromocodeInput {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  code?: string | null;
  type?: PromocodeTypeEnum | null;
  amount?: number | null;
  expirationDate?: any | null;
  status?: PromocodeStatusEnum | null;
  maxUses?: number | null;
  changeMembershipLengthBy?: number | null;
  platform?: LinkPlatformInput | null;
  product?: LinkProductInput[] | null;
  isPauseTokenDisabled?: boolean | null;
  additionalTest?: LinkAdditionalTestInput[] | null;
}

export interface UpdateQuestionBankCategoryInput {
  id?: string | null;
  title?: string | null;
  isLive?: boolean | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  membershipLevel?: MembershipType | null;
  tabIndex?: number | null;
}

export interface UpdateQuestionBankInput {
  id?: string | null;
  questionBankCategory?: LinkQuestionBankCategoryInput | null;
  title?: string | null;
  questions?: LinkQuestionInput[] | null;
  questionIds?: string[] | null;
  order?: number | null;
  isLive?: boolean | null;
  history?: HistoryInput[] | null;
  passage?: PassageInput[] | null;
}

export interface UpdateQuestionCategoryInput {
  id?: string | null;
  title?: string | null;
  subjects?: LinkSubjectInput[] | null;
}

export interface UpdateQuestionInput {
  id?: string | null;
  title?: string | null;
  questionCategory?: LinkQuestionCategoryInput | null;
  subjects?: LinkSubjectInput[] | null;
  questionAsHtml?: string | null;
  testletScenario?: string | null;
  questionAsPlainText?: string | null;
  questionStem?: string | null;
  answerExplanationAsHtml?: string | null;
  answerExplanationAsPlainText?: string | null;
  order?: number | null;
  type?: QuestionTypeEnum | null;
  isTemplate?: boolean | null;
  templateName?: string | null;
  resetStatistics?: boolean | null;
  history?: HistoryInput[] | null;
  additionalInformation?: string | null;
  showMultipleSelectionLabel?: boolean | null;
  exhibit?: string | null;
  xRay?: string | null;
  photo?: string | null;
  patient?: string | null;
  chiefComplaint?: string | null;
  backgroundAndOrPatientHistory?: string | null;
  dentalHistory?: string | null;
  medicalHistory?: string | null;
  model3D?: string | null;
  currentFinding?: string | null;
  invertQuestionImages?: QuestionInvertTypeEnum | null;
  invertAnswerImages?: QuestionInvertTypeEnum | null;
  invertAnswerExplanationImages?: QuestionInvertTypeEnum | null;
  dentalChart?: string | null;
  periodontalChart?: string | null;
  panoramicChart?: string | null;
  questionPassage?: LinkQuestionPassageInput | null;
  endodonticTable?: any | null;
  orthodonticTable?: any | null;
  periodontalTable?: any | null;
  sourcesAndCredits?: string | null;
  answer?: AnswerInput[] | null;
}

export interface UpdateQuestionPassage {
  id: string;
  subject?: LinkSubjectInput | null;
  content?: string | null;
  title?: string | null;
  level?: LevelEnum[] | null;
  isTemplate?: boolean | null;
  templateName?: string | null;
  history?: HistoryInput[] | null;
}

export interface UpdateQuestionPassageBankInput {
  id?: string | null;
  title?: string | null;
  level?: LevelEnum | null;
  order?: number | null;
  isLive?: boolean | null;
  questionPassagesIds?: string[] | null;
  passageTime?: number | null;
  wpm?: number | null;
  history?: HistoryInput[] | null;
  questionPassages?: LinkQuestionPassageInput[] | null;
  subject?: LinkSubjectInput | null;
}

export interface UpdateRecommendedArticleGroupInput {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: GroupIcon | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  recommendedArticle?: LinkRecommendedArticleInput[] | null;
}

export interface UpdateRecommendedArticleInput {
  id?: string | null;
  name?: string | null;
  link?: string | null;
  recommendedArticleGroup?: LinkRecommendedArticleGroupInput | null;
  description?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
}

export interface UpdateRewardInput {
  id?: string | null;
  type?: RewardTypeEnum | null;
  countOfEarnedRewards?: number | null;
  value?: number | null;
  order?: number | null;
  description?: string | null;
  percentage?: number | null;
  isLive?: boolean | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateSchedulerInput {
  id?: string | null;
  phase1TaskIds?: string[] | null;
  phase2TaskIds?: string[] | null;
  phase3TaskIds?: string[] | null;
  phase1Title?: string | null;
  phase2Title?: string | null;
  phase3Title?: string | null;
  task?: LinkTaskInput[] | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateScreenshotFeedbackInput {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  page?: CMSScreenshotPages | null;
  platform?: LinkPlatformInput | null;
  images?: string[] | null;
}

export interface UpdateStrategyGroupInput {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: string | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  strategy?: LinkStrategyInput[] | null;
}

export interface UpdateStrategyInput {
  id?: string | null;
  coverImage?: string | null;
  title?: string | null;
  withWhiteImageBG?: boolean | null;
  description?: string | null;
  featuredArticleDescription?: string | null;
  author?: LinkTeamMemberInput | null;
  fullName?: string | null;
  avatar?: string | null;
  secondaryLine?: string | null;
  content?: string | null;
  tableOfContent?: TableOfContentInput[] | null;
  slug?: string | null;
  membershipLevel?: MembershipType | null;
  order?: number | null;
  strategyGroup?: LinkStrategyGroupInput | null;
}

export interface UpdateStudyGuideInput {
  id?: string | null;
  coverImage?: string | null;
  title?: string | null;
  withWhiteImageBG?: boolean | null;
  description?: string | null;
  featuredArticleDescription?: string | null;
  author?: LinkTeamMemberInput | null;
  fullName?: string | null;
  avatar?: string | null;
  score?: string | null;
  guideAsHtml?: string | null;
  tableOfContent?: TableOfContentInput[] | null;
  similarGuides?: string[] | null;
  slug?: string | null;
  icon?: StudyGuideIconEnum | null;
  section?: LinkStudyGuideSectionInput[] | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateStudyGuideSectionInput {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  platform?: LinkPlatformInput | null;
  studyGuideIds?: string[] | null;
  studyGuide?: LinkStudyGuideInput[] | null;
}

export interface UpdateStudyNoteGroupInput {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  color?: string | null;
  icon?: GroupIcon | null;
  order?: number | null;
  subject?: LinkSubjectInput | null;
  studyNote?: LinkStudyNoteInput[] | null;
}

export interface UpdateStudyNoteInput {
  id?: string | null;
  name?: string | null;
  isBoosterEnvironment?: boolean | null;
  link?: string | null;
  landingPageDescription?: string | null;
  studyNoteGroup?: LinkStudyNoteGroupInput | null;
  description?: string | null;
  order?: number | null;
  membershipLevel?: MembershipType | null;
  isDocumentUpdated?: boolean | null;
}

export interface UpdateStudyScheduleInput {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  week8url?: string | null;
  week10url?: string | null;
  week12url?: string | null;
  week8settingsTitle?: string | null;
  week8settingsDescription?: string | null;
  week10settingsTitle?: string | null;
  week10settingsDescription?: string | null;
  week12settingsTitle?: string | null;
  week12settingsDescription?: string | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateStudyToolsDescriptionInput {
  id?: string | null;
  page?: string | null;
  description?: string | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateSubjectInput {
  id?: string | null;
  platform?: LinkPlatformInput | null;
  icon?: string | null;
  tabName?: string | null;
  type?: SubjectEnumType | null;
  slug?: string | null;
  order?: number | null;
  isHidden?: boolean | null;
  questionBankDescription?: string[] | null;
}

export interface UpdateSuccessStoryInput {
  id?: string | null;
  coverImage?: string | null;
  title?: string | null;
  withWhiteImageBG?: boolean | null;
  description?: string | null;
  featuredArticleDescription?: string | null;
  author?: LinkTeamMemberInput | null;
  fullName?: string | null;
  score?: string | null;
  storyAsHtml?: string | null;
  tableOfContent?: TableOfContentInput[] | null;
  studentsLikeYou?: string[] | null;
  slug?: string | null;
  section?: LinkSuccessStorySectionInput[] | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateSuccessStorySectionInput {
  id?: string | null;
  title?: string | null;
  order?: number | null;
  description?: string | null;
  platform?: LinkPlatformInput | null;
  successStoryIds?: string[] | null;
  successStory?: LinkSuccessStoryInput[] | null;
}

export interface UpdateTaskInput {
  id?: string | null;
  title?: string | null;
  type?: TaskTypeEnum | null;
  time?: number | null;
  description?: string | null;
  link?: string | null;
  platform?: LinkPlatformInput | null;
  subject?: LinkSubjectInput | null;
}

export interface UpdateTeamMemberInput {
  id?: string | null;
  fullName?: string | null;
  avatar?: string | null;
  degree?: string | null;
  university?: string | null;
  position?: string | null;
  authorPageDescription?: string | null;
  authorPageCredentials?: string | null;
  authorPageHighlights?: string | null;
  videoInstructorDescription?: string | null;
  aboutAuthorDescription?: string | null;
  slug?: string | null;
  link?: LinkTmLinkInput[] | null;
}

export interface UpdateTestimonialInput {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  pageWithOrder?: PageWithOrderInput[] | null;
  platform?: LinkPlatformInput | null;
  textFeedback?: LinkTextFeedbackInput[] | null;
}

export interface UpdateTextFeedbackInput {
  id?: string | null;
  shortFeedback?: string | null;
  fullFeedback?: string | null;
  student?: CMSStudentInput | null;
  isSelected?: boolean | null;
  order?: number | null;
  testimonial?: LinkTestimonialInput | null;
}

export interface UpdateTmLinkInput {
  id?: string | null;
  teamMember?: LinkTeamMemberInput | null;
  order?: number | null;
  platform?: LinkPlatformInput | null;
}

export interface UpdateUpgradePageInput {
  id?: string | null;
  title?: string | null;
  isPopular?: boolean | null;
  salesPrice?: number | null;
  originalPrice?: number | null;
  features?: string[] | null;
  mainDescription?: string | null;
  description?: string | null;
  isForNewUsers?: boolean | null;
  platform?: LinkPlatformInput | null;
  stripeProductId?: string | null;
  mainBadge?: MainBadgeEnum | null;
  secondaryBadge?: SecondaryBadgeEnum | null;
  showMaxBadge?: boolean | null;
  isPassGuaranteed?: boolean | null;
  isAfterpaySupported?: boolean | null;
}

export interface UpdateUserInput {
  firstName?: string | null;
  lastName?: string | null;
  avatar?: string | null;
  isBlocked?: boolean | null;
  isMFAMandatory?: boolean | null;
  isBetaTester?: boolean | null;
  studyScheduleIsWeekStartsOnMonday?: boolean | null;
  studyScheduleTaskView?: StudyScheduleTaskViewEnum | null;
  studyScheduleView?: StudyScheduleViewEnum | null;
  studyScheduleIsHideCompletedTask?: boolean | null;
  studyScheduleIsHideModal?: boolean | null;
  studyScheduleStudySpeed?: UserStudyScheduleStudySpeedEnum | null;
  blockReason?: string | null;
  countdownToExam?: ExamCountdownInput[] | null;
  onboardingData?: OnboardingDataInput[] | null;
  selectedPlatformId?: string | null;
  facultyModeProduct?: PlatformName | null;
  facultyModeSchool?: DentalSchoolsEnum | null;
  facultyModeCohort?: FacultyModeCohortYearEnum | null;
  lastLogin?: any | null;
  useNewScores?: boolean | null;
  dailyGoalStreak?: DailyGoalStreakInput[] | null;
  accommodation?: AccommodationInput[] | null;
  studyScheduleData?: StudyScheduleDataInput[] | null;
  userSettings?: any | null;
  dismissedUiKeys?: string[] | null;
}

export interface UpdateUserRewardInput {
  id?: string | null;
  availableCount?: number | null;
  usedCount?: number | null;
  user?: LinkUserInput | null;
  reward?: LinkRewardInput | null;
}

export interface UpdateVideoCategoryInput {
  id?: string | null;
  title?: string | null;
  subject?: LinkSubjectInput | null;
  order?: number | null;
  description?: string | null;
  membershipLevel?: MembershipType | null;
  isLive?: boolean | null;
  chapterCompletionTitle?: string | null;
  chapterCompletionDescription?: string | null;
  chapterCompletionBtn?: string | null;
  chapterCompletionBtnUrl?: string | null;
  chapterNotCompletionTitle?: string | null;
  chapterNotCompletionDescription?: string | null;
  chapterNotCompletionBtn?: string | null;
  chapterNotCompletionBtnUrl?: string | null;
  chapterCompletionLive?: boolean | null;
  video?: LinkVideoInput[] | null;
  author?: LinkTeamMemberInput | null;
}

export interface UpdateVideoInput {
  id?: string | null;
  title?: string | null;
  membershipLevel?: MembershipType | null;
  order?: number | null;
  link?: string | null;
  videoLength?: number | null;
  isLive?: boolean | null;
  resourseURL?: string | null;
  questionIds?: string[] | null;
  questions?: LinkQuestionInput[] | null;
  history?: HistoryInput[] | null;
  tags?: string[] | null;
}

export interface UpdateVideoReviewInput {
  id?: string | null;
  video?: string | null;
  thumbnail?: string | null;
  avatar?: string | null;
  fullName?: string | null;
  description?: string | null;
  videoReviewSection?: LinkVideoReviewSectionInput | null;
  isLive?: boolean | null;
  videoFileName?: string | null;
}

export interface UpdateVideoReviewSectionInput {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  platform?: LinkPlatformInput | null;
}

export interface UpgradePageOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  salesPrice?: OrderDirection | null;
}

export interface UpgradePageQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: UpgradePageWhere | null;
  order?: UpgradePageOrder | null;
}

export interface UpgradePageWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  isPopular?: boolean | null;
  salesPrice?: number | null;
  originalPrice?: number | null;
  features?: string[] | null;
  mainDescription?: string | null;
  description?: string | null;
  isForNewUsers?: boolean | null;
  stripeProductId?: string | null;
  mainBadge?: MainBadgeEnum | null;
  secondaryBadge?: SecondaryBadgeEnum | null;
  showMaxBadge?: boolean | null;
  isPassGuaranteed?: boolean | null;
  isAfterpaySupported?: boolean | null;
  platform?: FindByPlatformInput | null;
}

export interface UserBlockHistoryOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface UserBlockHistoryQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: UserBlockHistoryWhere | null;
  order?: UserBlockHistoryOrder | null;
}

export interface UserBlockHistoryWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  counter?: number | null;
  status?: UserBlockHistoryStatusEnum | null;
  user?: LinkUserInput | null;
}

export interface UserInput {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  avatar?: string | null;
  role?: RolesEnum | null;
  isBlocked?: boolean | null;
  isMFAMandatory?: boolean | null;
  isBetaTester?: boolean | null;
  studyScheduleIsWeekStartsOnMonday?: boolean | null;
  studyScheduleTaskView?: StudyScheduleTaskViewEnum | null;
  studyScheduleView?: StudyScheduleViewEnum | null;
  studyScheduleIsHideCompletedTask?: boolean | null;
  studyScheduleIsHideModal?: boolean | null;
  studyScheduleStudySpeed?: UserStudyScheduleStudySpeedEnum | null;
  blockReason?: string | null;
  countdownToExam?: ExamCountdownInput[] | null;
  onboardingData?: OnboardingDataInput[] | null;
  selectedPlatform?: PlatformName | null;
  selectedPlatformId?: string | null;
  screenshotInfo?: UserScreenshotInfoInput[] | null;
  membershipUpdatedAt?: any | null;
  membership?: UpdateMembershipInput[] | null;
  facultyModeProduct?: PlatformName | null;
  facultyModeSchool?: DentalSchoolsEnum | null;
  facultyModeCohort?: FacultyModeCohortYearEnum | null;
  lastLogin?: any | null;
  useNewScores?: boolean | null;
  dailyWarmup?: DailyWarmupStatsInput[] | null;
  dailyGoalStreak?: DailyGoalStreakInput[] | null;
  notification?: NotificationInput[] | null;
  accommodation?: AccommodationInput[] | null;
  studyScheduleData?: StudyScheduleDataInput[] | null;
  userSettings?: any | null;
  dismissedUiKeys?: string[] | null;
}

export interface UserOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  email?: OrderDirection | null;
  fullName?: OrderDirection | null;
  expirationDate?: OrderDirection | null;
  countOfCities?: OrderDirection | null;
  countOfRegions?: OrderDirection | null;
  countOfBrowserIds?: OrderDirection | null;
}

export interface UserQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: UserWhere | null;
  order?: UserOrder | null;
}

export interface UserRewardLogOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface UserRewardLogQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: UserRewardLogWhere | null;
  order?: UserRewardLogOrder | null;
}

export interface UserRewardLogWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  platform?: string | null;
  log?: string | null;
  user?: LinkUserInput | null;
}

export interface UserRewardOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface UserRewardQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: UserRewardWhere | null;
  order?: UserRewardOrder | null;
}

export interface UserRewardWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  availableCount?: number | null;
  usedCount?: number | null;
  user?: LinkUserInput | null;
  reward?: FindByRewardInput | null;
}

export interface UserScreenshotInfoInput {
  platform: PlatformName;
  screenshotCounter: number;
  latestScreenshotAt?: any | null;
  totalScreenshotsCount: number;
}

export interface UserStatsPracticeTestOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  attemptNumber?: OrderDirection | null;
  totalTimeSpentCount?: OrderDirection | null;
  answeredCorrectlyCount?: OrderDirection | null;
  practiceTest?: PracticeTestTitleOrder | null;
  estimatedDATScore?: OrderDirection | null;
}

export interface UserStatsPracticeTestQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: UserStatsPracticeTestWhere | null;
  order?: UserStatsPracticeTestOrder | null;
}

export interface UserStatsPracticeTestWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  practiceTest: PracticeTestUserStatsWhere;
  attemptNumber?: number | null;
  answeredCorrectlyCount?: number | null;
  totalQuestionsCount?: number | null;
  totalTimeSpentCount?: number | null;
  markedQuestionCount?: number | null;
  avgStudentScore?: number | null;
  estimatedDATScore?: number | null;
  feedback?: string | null;
  isFullLengthTest?: boolean | null;
  questionIds?: string[] | null;
  isCompleted?: boolean | null;
  sectionIndex?: number | null;
  testQuestionIds?: string[] | null;
  testPassageIds?: string[] | null;
  reportByQuestionCategory?: ReportByCategoryInput[] | null;
  reportByPassage?: ReportByPassageInput[] | null;
  isBlindReview?: boolean | null;
  user?: LinkUserInput | null;
  userAnswers?: LinkUserAnswerInput[] | null;
}

export interface UserWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  avatar?: string | null;
  role?: RolesEnum | null;
  isBlocked?: boolean | null;
  isMFAMandatory?: boolean | null;
  isBetaTester?: boolean | null;
  studyScheduleIsWeekStartsOnMonday?: boolean | null;
  studyScheduleTaskView?: StudyScheduleTaskViewEnum | null;
  studyScheduleView?: StudyScheduleViewEnum | null;
  studyScheduleIsHideCompletedTask?: boolean | null;
  studyScheduleIsHideModal?: boolean | null;
  studyScheduleStudySpeed?: UserStudyScheduleStudySpeedEnum | null;
  blockReason?: string | null;
  countdownToExam?: ExamCountdownInput[] | null;
  onboardingData?: OnboardingDataInput[] | null;
  selectedPlatform?: PlatformName | null;
  selectedPlatformId?: string | null;
  screenshotInfo?: UserScreenshotInfoInput[] | null;
  membershipUpdatedAt?: any | null;
  membership?: UpdateMembershipInput[] | null;
  facultyModeProduct?: PlatformName | null;
  facultyModeSchool?: DentalSchoolsEnum | null;
  facultyModeCohort?: FacultyModeCohortYearEnum | null;
  lastLogin?: any | null;
  useNewScores?: boolean | null;
  dailyWarmup?: DailyWarmupStatsInput[] | null;
  dailyGoalStreak?: DailyGoalStreakInput[] | null;
  notification?: NotificationInput[] | null;
  accommodation?: AccommodationInput[] | null;
  studyScheduleData?: StudyScheduleDataInput[] | null;
  userSettings?: any | null;
  dismissedUiKeys?: string[] | null;
  activeMembershipOn?: PlatformName | null;
  membershipStatus?: MembershipStatus | null;
  duration?: string | null;
  expirationDateRange?: EntityDateRangeFilterInput | null;
  expiresAt?: any | null;
}

export interface VideoCategoryOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
  order?: OrderDirection | null;
}

export interface VideoCategoryQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: VideoCategoryWhere | null;
  order?: VideoCategoryOrder | null;
}

export interface VideoCategoryWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  subject?: LinkSubjectInput | null;
  order?: number | null;
  description?: string | null;
  membershipLevel?: MembershipType | null;
  isLive?: boolean | null;
  chapterCompletionTitle?: string | null;
  chapterCompletionDescription?: string | null;
  chapterCompletionBtn?: string | null;
  chapterCompletionBtnUrl?: string | null;
  chapterNotCompletionTitle?: string | null;
  chapterNotCompletionDescription?: string | null;
  chapterNotCompletionBtn?: string | null;
  chapterNotCompletionBtnUrl?: string | null;
  chapterCompletionLive?: boolean | null;
  video?: LinkVideoInput[] | null;
  author?: LinkTeamMemberInput | null;
}

export interface VideoOrder {
  id?: OrderDirection | null;
  createdAt?: OrderDirection | null;
  deletedAt?: OrderDirection | null;
  updatedAt?: OrderDirection | null;
  version?: OrderDirection | null;
}

export interface VideoQueryInput {
  like?: string | null;
  skip?: number | null;
  take?: number | null;
  search?: SearchInput | null;
  startFrom?: string | null;
  filters?: BaseDateRangeFilter | null;
  relations?: string[] | null;
  where?: VideoWhere | null;
  order?: VideoOrder | null;
}

export interface VideoWhere {
  id?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  version?: number | null;
  title?: string | null;
  membershipLevel?: MembershipType | null;
  order?: number | null;
  link?: string | null;
  videoLength?: number | null;
  isLive?: boolean | null;
  resourseURL?: string | null;
  questionIds?: string[] | null;
  questions?: LinkQuestionInput[] | null;
  history?: HistoryInput[] | null;
  tags?: string[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
